/*
* Copyright (c) 2017 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of 2017 SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name:	GreenlightEvents.js
*
* Description:	Contains the code for the Greenlight Events.
* 
*/

$(function () {

	"use strict";

	// Determines if we are currently calling to try and reduce the amount of calls.
	var bTicking = false;

	// Determines the last time the scroll was used to move the canvas.
	var dtLastScroll = false;
	var bLastScrollCanvas = null;

	// Store the valid key(s) which have been pressed.
	var iaKeysPressed = [];

	// Flag to determine if the marquee zoom was the last used tool.
	var bIsMarqueeZoomLastTool = false;

	/**
	 * Mouse wheel event.
	 */
	$(window).on('wheel', function (event) {
		if (!bTicking) {
			window.requestAnimationFrame(function () {
				try {
					mouseWheelEvent(event);
				}
				catch (e) {
					// Error is thrown here when we try to zoom when the image is not loaded.
					// we don't have anything to return to the user when we catch the error,
					// we just want to ensure bTicking is set to False to allow zooming to continue functioning.
				}
				finally {
					bTicking = false;
				}
			});
		}
		bTicking = true;
	});

	/**
	 * Called on mouse wheel event.
	 * @param {object} event - The calling event.
	 */
	function mouseWheelEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		
		// Try to get the canvas using the id.
		var oCanvas = g_oViewer.getCanvas(event.target.id);

		// If we have found a suitable canvas.
		if (oCanvas != null) {

			// If the canvas is an annotation canvas.
			if (oCanvas.g_iCanvasType == eCanvasType.Annotation) {

				// Get the linked artwork canvas.
				oCanvas = g_oViewer.getLinkedArtworkCanvas(oCanvas.g_szCanvasId);
			}

			// Perform no actions if we are currently zooming.
			if (oCanvas.g_bIsAnimating) {
				return;
			}

			// Get a list of any sync canvas.
			var oSyncCanvas = g_oCompare.getSyncCanvas(oCanvas);

			// If we are in side by side, we allow individual movement of canvas.
			if (g_oViewer.g_oCompareMode == eCompareMode.SideBySide) {
				oSyncCanvas = [];
			}

			// Determine if we have wheeled up or down.
			var bWheelUp = event.originalEvent.deltaY < 0; // DeltaY records vertical scroll, DeltaX and DeltaZ exist too.

			// Update the last scroll time and canvas.
			dtLastScroll = new Date();
			bLastScrollCanvas = oCanvas.g_szCanvasId;

			// If we are holding the shift key.
			if (event.shiftKey) {

				// Wheeled up.
				if (bWheelUp) {

					// Pan up.
					oCanvas.g_iDragOffset_y -= 10;
					oCanvas.g_iCenterShift_y -= 10;
					oCanvas.g_bIsDragging = true;
					oCanvas.redraw(true);

					// Pan up each sync canvas.
					for (var i = 0; i < oSyncCanvas.length; i++) {
						oSyncCanvas[i].g_iDragOffset_y -= 10;
						oSyncCanvas[i].g_iCenterShift_y -= 10;
						oSyncCanvas[i].g_bIsDragging = true;
						oSyncCanvas[i].redraw(true);
					}
				}
				// Wheeled down.
				else {

					// Pan down.
					oCanvas.g_iDragOffset_y += 10;
					oCanvas.g_iCenterShift_y += 10;
					oCanvas.g_bIsDragging = true;
					oCanvas.redraw(true);

					// Pan down each sync canvas.
					for (var i = 0; i < oSyncCanvas.length; i++) {
						oSyncCanvas[i].g_iDragOffset_y += 10;
						oSyncCanvas[i].g_iCenterShift_y += 10;
						oSyncCanvas[i].g_bIsDragging = true;
						oSyncCanvas[i].redraw(true);
					}
				}

				// Attempt to redraw the canvas after 1 second.
				setTimeout(function () { mouseWheelRedraw(oCanvas, oSyncCanvas); }, 1000);
			}
			// If we are holding the ALT key.
			else if (event.altKey) {

				// Wheeled up.
				if (bWheelUp) {

					// Pan left.
					oCanvas.g_iDragOffset_x -= 10;
					oCanvas.g_iCenterShift_x -= 10;
					oCanvas.g_bIsDragging = true;
					oCanvas.redraw(true);

					// Pan left each sync canvas.
					for (var i = 0; i < oSyncCanvas.length; i++) {
						oSyncCanvas[i].g_iDragOffset_x -= 10;
						oSyncCanvas[i].g_iCenterShift_x -= 10;
						oSyncCanvas[i].g_bIsDragging = true;
						oSyncCanvas[i].redraw(true);
					}
				}
				// Wheeled down.
				else {

					// Pan right.
					oCanvas.g_iDragOffset_x += 10;
					oCanvas.g_iCenterShift_x += 10;
					oCanvas.g_bIsDragging = true;
					oCanvas.redraw(true);

					// Pan right each sync canvas.
					for (var i = 0; i < oSyncCanvas.length; i++) {
						oSyncCanvas[i].g_iDragOffset_x += 10;
						oSyncCanvas[i].g_iCenterShift_x += 10;
						oSyncCanvas[i].g_bIsDragging = true;
						oSyncCanvas[i].redraw(true);
					}
				}

				// Attempt to redraw the canvas after 1 second.
				setTimeout(function () { mouseWheelRedraw(oCanvas, oSyncCanvas); }, 1000);
			}
			// If we are not holding any action key.
			else if (!event.ctrlKey) {

				// If we are currently dragging, do not zoom.
				if (oCanvas.g_bIsDragging) {
					return;
				}

				// Wheeled up and we can zoom in.
				if (bWheelUp) {
					
					// Perform the scroll zoom.
					oCanvas.g_oCanvasZoom.scrollZoom(event, oSyncCanvas, parseInt(g_oSettings.g_oUserSettings.ScrollPreference));
				}
				// Wheeled down and we can zoom out.
				else if (!bWheelUp) {

					// Perform the scroll zoom out.
					oCanvas.g_oCanvasZoom.scrollZoomOut(event, oSyncCanvas, parseInt(g_oSettings.g_oUserSettings.ScrollPreference));
				}
			}
		}
	}

	/**
	 * Redraw the canvas if a second has passed since the last scroll event.
	 * @param {object} oCanvas - The canvas object to be redrawn.
	 * @param {object} oSyncCanvas - An array of synchronised canvases that also need redrawing.
	 */
	function mouseWheelRedraw(oCanvas, oSyncCanvas) {

		// Get the current date time.
		var dtNow = new Date();

		// If it has been 1 second since the last scroll, or we have changed the scroll canvas.
		if (((dtNow - dtLastScroll) / 1000) > 1 || bLastScrollCanvas != oCanvas.g_szCanvasId) {

			// Redraw the canvas.
			oCanvas.g_bIsDragging = false;
			oCanvas.redraw(true);

			// Redraw each sync canvas.
			for (var i = 0; i < oSyncCanvas.length; i++) {
				oSyncCanvas[i].g_bIsDragging = false;
				oSyncCanvas[i].redraw(true);
			}
		}
	}

	/*
	 * Page Navigation.
	 */

	$("#btnPageBack").click(function () {
		if (g_oViewer.g_oArtworkViewer.g_iCurrentPage !== 1) {
			if (!g_oAnnotations.checkForUnsavedAnnotation()) {
				g_oViewer.g_oArtworkViewer.g_iCurrentPage--;
				g_oViewer.g_oArtworkViewer.changeCurrentPage();
				EventService.publish("changeCurrentPage", g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
				var thisParent = $(this).parent();
				highlightSelectedButton(thisParent, false);
				setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);
			}
		}
	});

	$("#btnPageForward").click(function () {
		if (g_oViewer.g_oArtworkViewer.g_iCurrentPage !== g_oViewer.g_oArtworkViewer.g_oDoc.pages.length) {
			if (!g_oAnnotations.checkForUnsavedAnnotation()) {
				g_oViewer.g_oArtworkViewer.g_iCurrentPage++;
				g_oViewer.g_oArtworkViewer.changeCurrentPage();
				EventService.publish("changeCurrentPage", g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
				var thisParent = $(this).parent();
				highlightSelectedButton(thisParent, false);
				setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);
			}
		}
	});

	/*
	 * Artwork Navigation.
	 */

	$("#btnPan").click(function () {

		// If we have an active text highlight, end this and switch to the pan tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			changeCanvasFunction($("#AnnotationViewer"), 'pointermove.annotationUI', function (event) {});
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
		}

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		g_oAnnotations.currentTimeoutListClear();	// Ensure that an annotation save action doesn't overwrite this function's event handlers.
		$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
		$("#tblTextCompareTools .selectedButton").removeClass("selectedButton");

		var thisParent = $(this).parent();
		highlightButtonClearingAllIcons(thisParent, true);

		// Close all annotations.
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			g_oAnnotations.g_oAnnotationsMade[i].g_bClosed = true;
		}
		g_oTechTools.g_oAnnotationViewer.redraw(false);

		// Setup the pan on the main canvas.
		g_oViewer.pan(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
		g_oCompare.pan(g_oCompare.getSyncCanvas(g_oCompare.g_oCompareViewer));
	});

	// Individual pan buttons.
	$("#btnPan_Viewer, #btnPan_Compare, #btnPan_Viewer_TextCompare, #btnPan_Compare_TextCompare").click(function () {

		// If we have an active text highlight, end this and switch to the marquee tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			changeCanvasFunction($("#AnnotationViewer"), 'pointermove.annotationUI', function (event) { });
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
		}

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
		$("#tblTextCompareTools .selectedButton").removeClass("selectedButton");

		// Highlight the icons.
		switch (this.id) {
			case "btnPan_Viewer":
			case "btnPan_Compare":
				highlightSelectedButton($("#btnPan_Viewer"), false);
				highlightSelectedButton($("#btnPan_Compare"), false);
				break;
			case "btnPan_Viewer_TextCompare":
			case "btnPan_Compare_TextCompare":
				highlightSelectedButton($("#btnPan_Viewer_TextCompare"), false);
				highlightSelectedButton($("#btnPan_Compare_TextCompare"), false);
				break;
		}

		// Setup the pan on the main and compare canvas.
		g_oViewer.pan([]);
		g_oCompare.pan([]);
	});

	// Individual rotate buttons.
	$("#btnRotate, #btnRotateAnti, #btnRotate_Viewer, #btnRotate_Viewer_Anti, #btnRotate_Compare, #btnRotate_Compare_Anti, #btnRotate_Viewer_Anti_TextCompare, #btnRotate_Viewer_TextCompare, #btnRotate_Compare_Anti_TextCompare, #btnRotate_Compare_TextCompare").click(function () {
		
		// If we have an active text highlight, end this and switch to the marquee tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			changeCanvasFunction($("#AnnotationViewer"), 'pointermove.annotationUI', function (event) { });
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
		}

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Determine direction
		var iRotDegrees = $(this).data('rotation');

		// Perform the rotation.
		switch (this.id) {
			case "btnRotate":
			case "btnRotateAnti":
				g_oViewer.rotate(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer), iRotDegrees);
				break;
			case "btnRotate_Viewer":
			case "btnRotate_Viewer_Anti":
			case "btnRotate_Viewer_TextCompare":
			case "btnRotate_Viewer_Anti_TextCompare":
				g_oViewer.rotate([], iRotDegrees);
				break;
			case "btnRotate_Compare":
			case "btnRotate_Compare_Anti":
			case "btnRotate_Compare_TextCompare":
			case "btnRotate_Compare_Anti_TextCompare":
				g_oCompare.rotate([], iRotDegrees);
				break;
		}
	});

	// Individual text highlight buttons.
	$("#btnTextHighlight_Viewer_TextCompare, #btnTextHighlight_Compare_TextCompare, #btnParagraphHighlight_Viewer_TextCompare, #btnParagraphHighlight_Compare_TextCompare, #btnAreaTextHighlight_Viewer_TextCompare, #btnAreaTextHighlight_Compare_TextCompare").click(function (event) {
		
		// If we have calculated differences, this can not be used.
		if (g_oTextCompare.g_bDifferencesCalculated) {
			g_oGreenlightMessages.displayWarningBubble("Cannot use when in differences mode.");
			return;
		}

		// If text has not been loaded for one or more canvas, this can not be used.
		if (!g_oTextCompare.g_bArtworkTextDataLoaded || !g_oTextCompare.g_bCompareTextDataLoaded) {
			g_oGreenlightMessages.displayErrorBubble("One or more documents have no live text.");
			return;
		}

		// Remove any existing text highlight info bubbles.
		$(".speechbubble__texthighlight").parents(".bubbleInfo").remove();

		// If we are in a text highlight, this must be ended first, without automatically activating the pan tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			g_oTextCompare.g_bAutoActivatePanTool = false;
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
			g_oTextCompare.g_bAutoActivatePanTool = true;
		}

		// If the review screen is open, close this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Clear the selected button.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
		$("#tblTextCompareTools .selectedButton").removeClass("selectedButton");

		// Highlight the selected button.
		highlightSelectedButton($("#" + this.id), false);

		// Activate the text compare highlight.
		switch (this.id) {
			case "btnTextHighlight_Viewer_TextCompare":
				g_oTextCompare.initialiseTextCompareHighlight(false, null);
				break;
			case "btnTextHighlight_Compare_TextCompare":
				g_oTextCompare.initialiseTextCompareHighlight(true, null);
				break;
			case "btnParagraphHighlight_Viewer_TextCompare":
				g_oTextCompare.initialiseTextCompareParagraphHighlight(false, null);
				break;
			case "btnParagraphHighlight_Compare_TextCompare":
				g_oTextCompare.initialiseTextCompareParagraphHighlight(true, null);
				break;
			case "btnAreaTextHighlight_Viewer_TextCompare":
				g_oTextCompare.initialiseTextCompareAreaHighlight(false, null);
				break;
			case "btnAreaTextHighlight_Compare_TextCompare":
				g_oTextCompare.initialiseTextCompareAreaHighlight(true, null);
				break;
		}
	});

	$("#btnZoomIn").click(function (event) {

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom in.
		g_oViewer.zoomIn(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
	});

	$("#btnZoomOut").click(function () {

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom out.
		g_oViewer.zoomOut(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
	});

	$("#btnZoomIn_Viewer, #btnZoomIn_Compare, #btnZoomIn_Viewer_TextCompare, #btnZoomIn_Compare_TextCompare").click(function (event) {
		
		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom in.
		switch (this.id) {
			case "btnZoomIn_Viewer":
			case "btnZoomIn_Viewer_TextCompare":
				g_oViewer.zoomIn([]);
				break;
			case "btnZoomIn_Compare":
			case "btnZoomIn_Compare_TextCompare":
				g_oCompare.zoomIn([]);
				break;
		}
	});

	$("#btnZoomOut_Viewer, #btnZoomOut_Compare, #btnZoomOut_Viewer_TextCompare, #btnZoomOut_Compare_TextCompare").click(function () {

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom out.
		switch (this.id) {
			case "btnZoomOut_Viewer":
			case "btnZoomOut_Viewer_TextCompare":
				g_oViewer.zoomOut([]);
				break;
			case "btnZoomOut_Compare":
			case "btnZoomOut_Compare_TextCompare":
				g_oCompare.zoomOut([]);
				break;
		}
	});

	$("#btnZoomReset").click(function () {

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom reset.
		g_oViewer.zoomReset(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
	});

	$("#btnZoomReset_Viewer, #btnZoomReset_Compare, #btnZoomReset_Viewer_TextCompare, #btnZoomReset_Compare_TextCompare").click(function () {

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom reset.
		switch (this.id) {
			case "btnZoomReset_Viewer":
			case "btnZoomReset_Viewer_TextCompare":
				g_oViewer.zoomReset([]);
				break;
			case "btnZoomReset_Compare":
			case "btnZoomReset_Compare_TextCompare":
				g_oCompare.zoomReset([]);
				break;
		}
	});

	$("#btnZoomMarquee").click(function (event) {

		// If we have an active text highlight, end this and switch to the marquee tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			changeCanvasFunction($("#AnnotationViewer"), 'pointermove.annotationUI', function (event) { });
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
		}

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		g_oAnnotations.currentTimeoutListClear();	// Ensure that an annotation save action doesn't overwrite this function's event handlers.
		$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
		$("#tblTextCompareTools .selectedButton").removeClass("selectedButton");
		var thisParent = $(this).parent();
		highlightButtonClearingAllIcons(thisParent, true);

		// Setup the marquee zoom.
		g_oViewer.marqueeZoom(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
		g_oCompare.marqueeZoom(g_oCompare.getSyncCanvas(g_oCompare.g_oCompareViewer));
	});

	$("#btnZoomMarquee_Viewer, #btnZoomMarquee_Compare, #btnZoomMarquee_Viewer_TextCompare, #btnZoomMarquee_Compare_TextCompare").click(function (event) {

		// If we have an active text highlight, end this and switch to the marquee tool.
		if (g_oTextTools.g_bHighlightInProgress) {
			changeCanvasFunction($("#AnnotationViewer"), 'pointermove.annotationUI', function (event) { });
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
		}

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
		$("#tblTextCompareTools .selectedButton").removeClass("selectedButton");

		// Highlight the correct icons.
		switch (this.id) {
			case "btnZoomMarquee_Viewer":
			case "btnZoomMarquee_Compare":
				highlightSelectedButton($("#btnZoomMarquee_Viewer"), false);
				highlightSelectedButton($("#btnZoomMarquee_Compare"), false);
				break;
			case "btnZoomMarquee_Viewer_TextCompare":
			case "btnZoomMarquee_Compare_TextCompare":
				highlightSelectedButton($("#btnZoomMarquee_Viewer_TextCompare"), false);
				highlightSelectedButton($("#btnZoomMarquee_Compare_TextCompare"), false);
				break;
		}

		// Setup the marquee zoom.
		g_oViewer.marqueeZoom([]);
		g_oCompare.marqueeZoom([]);
	});

	// Clear text functionality.
	$("#btnTextClear_Viewer_TextCompare, #btnTextClear_Compare_TextCompare, #btnTextClear_Common_TextCompare").click(function () {

		// If we have calculated differences, this can not be used.
		if (g_oTextCompare.g_bDifferencesCalculated) {
			g_oGreenlightMessages.displayWarningBubble("Cannot use when in differences mode.");
			return;
		}

		// If we have an active text highlight, do not allow this.
		if (g_oTextTools.g_bHighlightInProgress) {
			g_oGreenlightMessages.displayWarningBubble("Cannot use when highlighting.");
			return;
		}

		// Setup the icon.
		var thisParent = $(this).parent();
		highlightSelectedButton(thisParent, false);
		setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);

		// Perform the zoom reset.
		switch (this.id) {
			case "btnTextClear_Viewer_TextCompare":
				g_oTextCompare.clearTextData(true, false, false);
				break;
			case "btnTextClear_Compare_TextCompare":
				g_oTextCompare.clearTextData(false, true, false);
				break;
			case "btnTextClear_Common_TextCompare":
				g_oTextCompare.clearTextData(true, true, false);
				break;
		}
	});

	/**
	 * Approve Button.
	 */
	$("#btnConfirmApprove").click(function () {

		// If the current document is a 3D preview, we need to confirm the approval.
		if (isCurrentDocumentThreeDPreview()) {
			var UserHasConfirmed = function () {
				ConfirmApprove();
			};

			// Your decision will be applied to the parent 2D document. Continue?
			g_oGreenlightMessages.displayConfirmBubble(g_oThreeDView.c_szThreeDViewApprovalDecision, UserHasConfirmed, unlockScreen);
			return;
		}

		// Confirm the approval.
		ConfirmApprove();
	});

	/**
	 * Conditional Approve Button.
	 */
	$("#btnConfirmConditionalApprove").click(function () {

		// If the current document is a 3D preview, we need to confirm the approval.
		if (isCurrentDocumentThreeDPreview()) {
			var UserHasConfirmed = function () {
				ConfirmConditionalApprove();
			};

			// Your decision will be applied to the parent 2D document. Continue?
			g_oGreenlightMessages.displayConfirmBubble(g_oThreeDView.c_szThreeDViewApprovalDecision, UserHasConfirmed, unlockScreen);
			return;
		}

		// Confirm the conditional approval.
		ConfirmConditionalApprove();
	});

	/**
	 * Reject Button.
	 */
	$("#btnConfirmReject").click(function () {

		// If the current document is a 3D preview, we need to confirm the rejection.
		if (isCurrentDocumentThreeDPreview()) {
			var UserHasConfirmed = function () {
				ConfirmReject();
			};

			// Your decision will be applied to the parent 2D document. Continue?
			g_oGreenlightMessages.displayConfirmBubble(g_oThreeDView.c_szThreeDViewApprovalDecision, UserHasConfirmed, unlockScreen);
			return;
		}

		// Confirm the rejection.
		ConfirmReject();
	});

	/*
	 * Checks if the active document is a 3D Preview.
	 */
	function isCurrentDocumentThreeDPreview() {
		// All documents on the approval will be in this object.
		var oApprovalFiles = g_oApprovalFiles.g_oControlIndex[comboControl_GetControlById("approvalNameComboControl", true)];
		// The index of the currently active document.
		var iCurrentDocumentIndex = oApprovalFiles.g_iCurrentDocIndex;

		//If the currently active document is a 3D Preview, add a confirmation box
		return oApprovalFiles.g_Docs[iCurrentDocumentIndex].document.Approval3DViewId > -1;
	}

	/*
	 * Approve Approval function.
	 */
	function ConfirmApprove() {

		// Ensure the approval conditions have been met.
		if (!g_oApproval.ApprovalConditionsMet(true)) {
			return;
		}

		// Set the approver status.
		g_oApproval.SetApproverStatus(eApproverStatus.Approved);
	}

	/**
	 * Approve Conditional function.
	 */
	function ConfirmConditionalApprove() {

		// Ensure the approval conditions have been met.
		if (!g_oApproval.ApprovalConditionsMet(true)) {
			return;
		}

		// Set the approver status.
		g_oApproval.SetApproverStatus(eApproverStatus.ApprovedChanges);
	}

	/*
	 * Reject Approval function.
	 */
	function ConfirmReject() {

		// Ensure the rejection conditions have been met.
		if (!g_oApproval.RejectionConditionsMet(true)) {
			return;
		}

		// If this is a multi file approval, we need to check for annotations on other documents.
		var oApprovalFiles = g_oApprovalFiles.g_oControlIndex[comboControl_GetControlById("approvalNameComboControl", true)];
		if (oApprovalFiles.g_Docs.length > 1) {
			ConfirmRejectMultiple();
			return;
		}

		// Set the approver status.
		g_oApproval.SetApproverStatus(eApproverStatus.Rejected);
	}

	/*
	 * Reject Multiple Approval function.
	 */
	function ConfirmRejectMultiple() {

		// Get the approval files.
		var oApprovalFiles = g_oApprovalFiles.g_oControlIndex[comboControl_GetControlById("approvalNameComboControl", true)];

		// Hide the reject button.
		$("#divRejectionDropDown").toggle(false);

		// Lock the screen.
		lockScreen();

		// Create Server Call for the data.
		// Get the first doc's approval id (all should be the same).
		var oJSON = {
			ApprovalId: oApprovalFiles.g_Docs[0].greenlightApprovalId
		};

		// Call to check for approval annotations.
		$.post({
			url: "GreenlightApproval/CheckApprovalAnnotations",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse, Status, jqXHR) {
				if (oResponse.Success) {
					if (oResponse.Contents === "True") {
						g_oApproval.SetApproverStatus(eApproverStatus.Rejected);
					}
					else {
						g_oGreenlightMessages.displayWarningBubble(c_szMissingAnnotationsWarning);
					}
				} else {
					g_oGreenlightMessages.displayErrorBubble(displayErrorContentHTML(oResponse.Errors));
				}
			}
		})
		.always(function () {
			unlockScreen();
		});
	}

	/**
	 * Approvers Info.
	*/

	$("#btnInfo").click(function () {
		var thisParent = $(this).parent();
		var bOpen = thisParent.find(".dropdown-content").is(":visible");
		highlightSelectedButton(thisParent, true);
		if (!bOpen) {
			$("#divInfoDropDown").slideToggle(200);
		} else {
			clearHighlightSelectedButton(thisParent);
		}
	});

	/**
	* Drag and drop for speech bubbles
	*/

	$("#divViewerCell").on("pointerdown", ".speechbubble", function (e) {
		
		// If the target is a JQTE tool, ignore this pointer down event.
		if (e.target.className.indexOf("jqte_tool_icon") !== -1) {
			return;
		}

		// Due to the popup content being a scrollable area, we do not was to drag when clicking the scrollbar.
		if (e.target.className.indexOf("popup-content") !== -1) {
			return;
		}

		// Check if the colour selection has been selected, if so we don't want to enable dragging.
		if (e.target.className.indexOf("annotationColorSelection") !== -1) {
			return;
		}

		// Check if text classification data has been selected, if so we don't want to enable dragging.
		if (e.target.className.indexOf("TextClassificationAnnotationText") !== -1 || ($(e.target).parents(".TextClassificationAnnotationText").length > 0)) {
			return;
		}

		// Increment the annotation z-index.
		g_oAnnotations.zindex++;

		// Get the artwork and annotation canvas based on the speech bubble.
		var oArtworkCanvas = g_oViewer.getCanvas($(this).attr("data-artworkCanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		$(this).css("z-index", g_oAnnotations.zindex);
		var origCoords = getClickCoords(e, oAnnotationCanvas);
		var currentPos = [parseInt($(this).css("left")), parseInt($(this).css("top"))];
		var that = this;

		$("#divViewerCell").on("pointermove", function (e) {
			var coords = getClickCoords(e, oAnnotationCanvas);
			$(that).css({
				"left": ((coords[0] - origCoords[0]) / g_oViewer.c_iDPI) + currentPos[0],
				"top": ((coords[1] - origCoords[1]) / g_oViewer.c_iDPI) + currentPos[1]
			});
			// Get rid of the :after triangle once dragged
			$(that).addClass("noAfter");
			oAnnotationCanvas.g_oContext.clearRect(0, 0, oAnnotationCanvas.g_oCanvas.width, oAnnotationCanvas.g_oCanvas.height);

			if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {
				g_oAnnotations.redrawAnnotations(oArtworkCanvas, oAnnotationCanvas);
			}
			else {
				g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
			}

			// Reposition the speech bubbles.
			g_oAnnotations.repositionSpeechBubbles(oArtworkCanvas, oAnnotationCanvas);

			// If this is not a threeD approval, redraw the annotation canvas.
			if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {
				oAnnotationCanvas.redraw(false);
			}

			$(this).on("pointerup", function (e) {
				$(this).off("pointermove");
			});
		});
	});

	// Prevents moving of the speech bubble div in SVG approval mode when highlighting text in the text area element
	$("#divViewerCell").on("pointerdown", "textarea", function (e) {
		$("textarea").off("pointermove");
		e.stopPropagation();
	});

	$("#divViewerCell").on("pointerdown", "input", function (e) {
		$("textarea").off("pointermove");
		e.stopPropagation();
	});

	/**
	* Annotations panel.
	*/

	$("#divAnnButton").click(function () {
		g_oViewer.toggleAnnotationsDiv();
	});

	/**
	* Separation panel.
	*/

	$("#divSepButton").click(function () {
		g_oViewer.toggleSeparationsDiv();
	});

	/**
	* CopyMagic panel.
	*/

	$("#divCopyMagicButton").click(function () {
		g_oSVGCopyMagic.toggleCopyMagicSlideOut();
	});

	// Enable all canvas images.
	$("#ResetSeparations").click(function () {

		// Enable all canvas images for the approval document.
		g_oSeparations.ResetAllCanvasImages(g_oViewer.g_oArtworkViewer);

		// Get any sync canvas.
		var oSyncCanvas = g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer);

		// Enable all canvas images for each of the sync canvas.
		for (var i = 0; i < oSyncCanvas.length; i++) {
			g_oSeparations.ResetAllCanvasImages(oSyncCanvas[i]);
		}
	});

	// Step through the separations.
	$("#imgStepThroughSeparations").click(function () {

		// Get any sync canvas.
		var oSyncCanvas = g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer);

		// Step through the separations.
		g_oSeparations.StepThroughCanvasImages(g_oViewer.g_oArtworkViewer, oSyncCanvas);
	});

	/**
	* Annotation Menu
	*/

	$("#btnAnnotate").click(function () {

		// If we have an active text highlight, prevent the drop down.
		if (g_oTextTools.g_bHighlightInProgress) {
			return;
		}

		// Reset flag as we're about to create an annotation.
		g_oAnnotations.g_bNonAnnotationActionInProgress = false;

		var thisParent = $(this).parent();
		var bOpen = thisParent.find(".dropdown-content").is(":visible");
		highlightButtonClearingAllIcons(thisParent, true);
		var bAnnotationMode = !bOpen;

		if (!bOpen) {
			$("#annotationDropDown").slideToggle(200);

			if (g_oAnnotations.g_iApprovalType !== eDocumentTypes.ThreeD
				|| g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType !== eDocumentTypes.ThreeD
				&& g_oViewer.g_oArtworkViewer.g_oDoc.documentType !== eDocumentTypes.ThreeD) {
				g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
			}
			else {
				$(".annotationType").hide();
			}
		}
		else {
			clearHighlightSelectedButton(thisParent);
		}

		// Set or unset the annotation mode if it's 3D.
		if (g_oViewer.g_oArtworkViewer.g_oDoc.documentType === eDocumentTypes.ThreeD) {
			// Make sure we are looking at the correct combo control.
			if (g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType === eDocumentTypes.ThreeD) {
				g_oViewer.g_oArtworkViewer.updateAnnotationMode(bAnnotationMode);
			}
		}
	});


	/**
	* Annotation Tool tip changes.
	*/

	$("#Postit").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 0);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	$("#Freedraw").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 1);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	$("#Rectangle").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 2);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	$("#Ellipse").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 3);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	$("#Line").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 4);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	$("#Global").on("click", function () {
		g_oAnnotations.toolTypeChange(this, 5);
		g_oAnnotations.initiateAnnotationDraw(0, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	/**
	 * Binding Key events
	 */
	$(document).on("keyup", function (e) {
		switch (e.keyCode) {
			case 27: // ESC
				// Reset the mouse cursor.
				$("#AnnotationViewer").css("cursor", "default");
				$("#CompareAnnotationViewer").css("cursor", "default");
				g_oAnnotations.g_szPrevCursorStyle = "default";

				// Remove all highlighted buttons.
				$(".techToolType").css("background-color", "");
				removeExistingHighlights(null);

				// If we are in the process of a text highlight, end the highlight.
				var bTextHighlightEnded = false;
				if (g_oTextTools.g_bHighlightInProgress) {
					bTextHighlightEnded = true;
					g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, true);
				}

				// Don't rebind the mouse logic if there are open editable speech bubbles
				if (!g_oAnnotations.checkIfNewSpeechBubbleExists()) {

					// Unselect all tech tools.
					g_oTechTools.g_iSelectedMeasurementType = g_oTechTools.g_eMeasurementTypes.NONE;
					g_oTechTools.clearBarcodeMeasurementArray();
					$("#divTechToolsClearCanvas").click();

					// Close all annotations.
					$(".speechbubble").remove();
					for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
						g_oAnnotations.g_oAnnotationsMade[i].g_bClosed = true;
					}

					g_oTechTools.g_oAnnotationViewer.redraw(false);
					g_oViewer.g_oArtworkViewer.dragDiscontinue(false, []);
					g_oAnnotations.g_oTempAnnotationArray.length = 0;

					// Redraw the compare canvas just in case.
					if (typeof g_oViewer.getCanvasByName("CompareAnnotationViewer") !== "undefined" && g_oViewer.getLinkedArtworkCanvas("CompareAnnotationViewer").g_oDoc !== null) {
						g_oViewer.getCanvasByName("CompareAnnotationViewer").redraw(false);
					}

					// Rebind mouseHover
					changeCanvasFunction();
					changeCanvasFunction("#AnnotationViewer", "pointermove.annotationUI", function (e) {
						AnnotationAction.prototype.mouseMoveLite(e, g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
					});

					var bAutoSelect = g_oTextCompare_AutoSelection.isAutoSelectionEnabled();

					if (!bAutoSelect) {
						// Close any open info bubbles.
						g_oGreenlightMessages.closeBubbles();
					}
				}
				// If a new speech bubble exists, and we have not just ended a text highlight.
				else if (!bTextHighlightEnded) {

					// Display a warning.
					g_oGreenlightMessages.displayWarningBubble(g_oAnnotations.c_szUnsavedAnnotation);
				}

				// Prevent default.
				e.preventDefault();
				break;
			case 16: // Shift
				// If we are in the process of a text highlight, toggle the highlight direction.
				if (g_oTextTools.g_bHighlightInProgress) {
					g_oTextTools.toggleHighlightDirection();
				}
				break;
			default:
				break;
		}
	});

	/**
	* Compare Menu
	*/

	$("#btnCompare").click(function () {

		// If we have an active text highlight, prevent the drop down.
		if (g_oTextTools.g_bHighlightInProgress) {
			return;
		}

		var thisParent = $(this).parent();
		var bOpen = thisParent.find(".dropdown-content").is(":visible");
		highlightSelectedButton(thisParent, true);
		if (!bOpen) {
			$("#compareDropDown").slideToggle(200);
		}
		else {
			clearHighlightSelectedButton(thisParent);
		}
	});

	/**
	* Compare Tool tip changes.
	*/

	$("#Blink").on("click", function () {
		g_oCompare.toolTypeChange(this, eCompareMode.Blink, false);
	});

	$("#Overlay").on("click", function () {
		g_oCompare.toolTypeChange(this, eCompareMode.Overlay, false);
	});

	$("#Slider").on("click", function (event) {

		// Determine the slider we have selected.
		g_oCompare.g_bSliderVertical = (event.target.id === "SliderImgVertical" ? true : false);

		// Set the slider type.
		var eSliderType = g_oCompare.g_bSliderVertical ? eCompareMode.SliderVertical : eCompareMode.SliderHorizontal;

		// Determine if we want to keep the current documents.
		var bKeepDocuments = (g_oViewer.g_oCompareMode == eCompareMode.SliderVertical || g_oViewer.g_oCompareMode == eCompareMode.SliderHorizontal);

		// Since we have seperated the horizontal / vertical into two seperate elements we now replace with the clickAction representing the required slider.
		g_oCompare.toolTypeChange(this, eSliderType, bKeepDocuments);
	});

	$("#SideBySide").on("click", function () {
		g_oCompare.toolTypeChange(this, eCompareMode.SideBySide, false);
	});

	$("#SideBySideDifference").on("click", function () {
		g_oCompare.toolTypeChange(this, eCompareMode.SideBySideDiff, false);
	});

	$("#DeactivateCompare").on("click", function () {
		// Close all annotations.
		$(".speechbubble").remove();
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			g_oAnnotations.g_oAnnotationsMade[i].g_bClosed = true;
		}
		g_oCompare.toolTypeClear(true);
		changeCanvasFunction();
	});

	$("#AnimateDifferencesToggle").on("click", function () {

		// Setup the Icon
		var thisParent = $(this).parent();
		var bOpen = thisParent.find(".dropdown-content").is(":visible");
		highlightSelectedButton(thisParent, true);

		// Check if on or off
		if (!g_oCompare.g_bIsAnimateDifferencesOn) {

			// Set the toggle to On & toggle image source
			g_oCompare.g_bIsAnimateDifferencesOn = true;
			$(this).attr("src", "img/Pause_32.png");
			$("#DiffSpeedSlider").show();

			// Toggle Animation
			g_oCompare.toggleDifferences();
		}
		else {

			// Set the toggle to Off & toggle image source.
			g_oCompare.g_bIsAnimateDifferencesOn = false;
			$(this).attr("src", "img/Play_32.png");

			$("#DiffSpeedSlider").hide();
		}
	});

	/*
	* Annotation Colour Change functions
	*/

	//-------------Annotation Colour Change Functions---------------

	// Blue
	$("#annotateBlue").on("click", function () {
		g_oAnnotations.annotationColourChange("blue");
	});

	// Red
	$("#annotateRed").on("click", function () {
		g_oAnnotations.annotationColourChange("red");
	});

	// Green
	$("#annotateGreen").on("click", function () {
		g_oAnnotations.annotationColourChange("green");
	});

	// Orange
	$("#annotateOrange").on("click", function () {
		g_oAnnotations.annotationColourChange("orange");
	});

	// Purple
	$("#annotatePurple").on("click", function () {
		g_oAnnotations.annotationColourChange("purple");
	});

	// Cyan
	$("#annotateCyan").on("click", function () {
		g_oAnnotations.annotationColourChange("cyan");
	});

	// Magenta
	$("#annotateMagenta").on("click", function () {
		g_oAnnotations.annotationColourChange("magenta");
	});

	// Yellow
	$("#annotateYellow").on("click", function () {
		g_oAnnotations.annotationColourChange("yellow");
	});

	// Grey
	$("#annotateGrey").on("click", function () {
		g_oAnnotations.annotationColourChange("grey");
	});

	// Annotation Colour Setting.
	$("#setting_AnnotationColour").on("click", function (event) {
		
		// Stop any default behaviour.
		event.preventDefault();
		event.stopPropagation();

		// Hide the colour grid if already shown.
		if ($("#settingAnnotationColourPopup").length > 0) {
			$("#settingAnnotationColourPopup").remove();
			return;
		}

		// Get the original table to clone from.
		var oColourGrid = document.getElementById("colourSelectionGridTable").cloneNode(true);

		// Update the grid settings.
		oColourGrid.id = "settingAnnotationColourPopup";
		oColourGrid.style.background = (g_oSettings.c_iSkinType == 0) ? "black" : "white";
		oColourGrid.style.display = "block";
		oColourGrid.style.zIndex = 1002;

		// Set the margin of the colour grid.
		oColourGrid.style['margin-top'] = "4px";
		oColourGrid.style['margin-left'] = "21px";

		// Add the required classes if we are on the light interface.
		if (g_oSettings.c_iSkinType == 1) {
			oColourGrid.classList.add("dvPopupAnnotationWhiteColour");
			oColourGrid.classList.add("colorWhiteSelection");
		}

		// Append the grid to the setting.
		$("#setting_AnnotationColour").parent()[0].appendChild(oColourGrid);
		
		// Set the selected colour.
		$("#settingAnnotationColourPopup").find(".annotationColorSelection").css("border-color", "transparent");
		$("#settingAnnotationColourPopup").find(".annotationColorSelection." + g_oAnnotations.getStringColour(g_oSettings.g_oUserSettings.AnnotationColour)).css("border-color", g_oSettings.c_iSkinType == 0 ? "white" : "black");
	});

	/**
	* Annotation events.
	*/

	// Hides our annotations.
	$("#HideAnnotations, #settings_ShowAnnotationsToggle").on("click", function () {

		// Toggle the annotation setting.
		g_oSettings.g_oUserSettings.ShowAnnotations = !g_oSettings.g_oUserSettings.ShowAnnotations;

		// If annotations are now hidden.
		if (!g_oSettings.g_oUserSettings.ShowAnnotations) {

			// Close any active annotations.
			g_oAnnotations.closeActiveAnnotations();

			// If we are currently finding SVG text.
			if (g_oViewer.c_bFindSVGText) {

				// Toggle this off.
				$("#btnSVGFindText").click();
			}
		}

		// Redraw the annotations based on the change.
		if (g_oAnnotations.g_iApprovalType === eDocumentTypes.ThreeD) {
			g_oAnnotations.redraw3DAnnotations(g_oAnnotations.g_oArtworkViewer, g_oAnnotations.g_oAnnotationViewer);
			g_oAnnotations.redraw3DAnnotations(g_oCompare.g_oCompareViewer, g_oCompare.g_oCompareAnnotationViewer);
		}
		else {
			g_oAnnotations.g_oAnnotationViewer.redraw(false);
			if (g_oViewer.g_oCompareMode != eCompareMode.NoCompare) {
				g_oCompare.g_oCompareAnnotationViewer.redraw(false);
			}
		}

		// Update the setting.
		g_oSettings.updateSettingShowAnnotations(true);
	});

	$("#ViewerCell").on("click", ".speechbubble", function (e) {
		$(this).css("z-index", g_oAnnotations.zindex + 1);
		g_oAnnotations.zindex++;
	});

	// Change function for the scroll type.
	$("#setting_ScrollPreference").on("change", function (e) {

		// Update the scroll preference.
		g_oSettings.g_oUserSettings.ScrollPreference = $("#setting_ScrollPreference").val();

		// Update the setting.
		g_oSettings.updateSettingScrollPreference(true);
	});

	// Change function for the zoom speed.
	$("#setting_ZoomSpeed").on("change", function (e) {

		// Update the zoom speed.
		g_oSettings.g_oUserSettings.ZoomSpeed = parseInt($("#setting_ZoomSpeed").val());

		// Update the setting.
		g_oSettings.updateSettingZoomSpeed(true);

		// Update the animation frames for each canvas. (3D Canvas do not use animation frames)
		for (var i = 0; i < g_oViewer.g_oActiveCanvasList.length; i++) {
			if (!g_oViewer.g_oActiveCanvasList[i].isThreeDCanvas) {
				g_oViewer.g_oActiveCanvasList[i].g_iAnimateFrames = getAnimationFramesForZoomSpeed(g_oSettings.g_oUserSettings.ZoomSpeed);
			}
		}
	});

	// Change function for the zoom increments.
	$("#setting_ZoomIncrements").on("change", function (e) {

		// Update the zoom increments.
		g_oSettings.g_oUserSettings.ZoomIncrements = parseInt($("#setting_ZoomIncrements").val());

		// Update the setting.
		g_oSettings.updateSettingZoomIncrements(true);

		// Update the zoom multipler for each canvas. (3D Canvas do not use zoom multipliers)
		for (var i = 0; i < g_oViewer.g_oActiveCanvasList.length; i++) {
			if (!g_oViewer.g_oActiveCanvasList[i].isThreeDCanvas) {
				g_oViewer.g_oActiveCanvasList[i].g_oCanvasZoom.g_iZoomMultiplier = getZoomMultiplierForZoomIncrement(g_oSettings.g_oUserSettings.ZoomIncrements);
			}
		}
	});

	// Change function for the alignment type.
	$("#setting_AlignmentPreference").on("change", function () {

		// Update the alignment preference.
		g_oSettings.g_oUserSettings.AlignmentPreference = $("#setting_AlignmentPreference").val();

		// Update the setting.
		g_oSettings.updateSettingAlignmentPreference(true);
	});

	// Change function for the highlight type.
	$("#setting_HighlightPreference").on("change", function () {

		// Update the highlight preference.
		g_oSettings.g_oUserSettings.HighlightPreference = $("#setting_HighlightPreference").val();

		// Update the setting.
		g_oSettings.updateSettingHighlightPreference(true);

		// If a text highlight is in progress, update the info bubble.
		if (g_oTextTools.g_bHighlightInProgress) {
			g_oTextTools.displayHighlightInfo();
		}
	});

	// Text Comparison Highlight Colour Setting.
	$("#setting_TextComparisonHighlightColour").on("click", function (event) {

		// Stop any default behaviour.
		event.preventDefault();
		event.stopPropagation();

		// Hide the colour grid if already shown.
		if ($("#settingTextComparisonHighlightColourPopup").length > 0) {
			$("#settingTextComparisonHighlightColourPopup").remove();
			return;
		}

		// Get the original table to clone from.
		var oColourGrid = document.getElementById("colourSelectionGridTable").cloneNode(true);

		// Update the grid settings.
		oColourGrid.id = "settingTextComparisonHighlightColourPopup";
		oColourGrid.style.background = (g_oSettings.c_iSkinType == 0) ? "black" : "white";
		oColourGrid.style.display = "block";
		oColourGrid.style.zIndex = 1002;

		// Set the margin of the colour grid.
		oColourGrid.style['margin-top'] = "4px";
		oColourGrid.style['margin-left'] = "21px";

		// Add the required classes if we are on the light interface.
		if (g_oSettings.c_iSkinType == 1) {
			oColourGrid.classList.add("dvPopupAnnotationWhiteColour");
			oColourGrid.classList.add("colorWhiteSelection");
		}

		// Append the grid to the setting.
		$("#setting_TextComparisonHighlightColour").parent()[0].appendChild(oColourGrid);

		// Set the selected colour.
		$("#settingTextComparisonHighlightColourPopup").find(".annotationColorSelection").css("border-color", "transparent");
		$("#settingTextComparisonHighlightColourPopup").find(".annotationColorSelection." + g_oAnnotations.getStringColour(g_oSettings.g_oUserSettings.TextComparisonHighlightColour)).css("border-color", g_oSettings.c_iSkinType == 0 ? "white" : "black");

		// Update the click event of the colour tiles.
		$("#settingTextComparisonHighlightColourPopup").find(".annotationColorSelection").off('click').on('click', function () {
			g_oTextCompare.updateTextCompareHighlightColour(this.getAttribute('data-annotationcolour'));
		});
	});

	// Change function for the text comaprison accuracy setting.
	$("#setting_TextComparisonAccuracy").on("change", function () {

		// Update the text comparison accuracy.
		g_oSettings.g_oUserSettings.TextComparisonAccuracy = $("#setting_TextComparisonAccuracy").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonAccuracy(true);

		// If we are not actively in a text comaprison, update the text comparison accuracy.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonAccuracy").val(g_oSettings.g_oUserSettings.TextComparisonAccuracy);
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Change function for the text comaprison sensitivity setting.
	$("#setting_TextComparisonCaseSensitivity").on("change", function () {

		// Update the text comparison accuracy.
		g_oSettings.g_oUserSettings.TextComparisonCaseSensitivity = $("#setting_TextComparisonCaseSensitivity").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonCaseSensitivity(true);

		// If we are not actively in a text comaprison, update the text comparison sensitivity.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonCaseSensitivity").val(g_oSettings.g_oUserSettings.TextComparisonCaseSensitivity);
		}
	});

	// Change function for the text comaprison bold italic detection setting.
	$("#setting_TextComparisonBoldItalicDetection").on("change", function () {

		// Update the text comparison bold italic detection.
		g_oSettings.g_oUserSettings.TextComparisonBoldItalicDetection = $("#setting_TextComparisonBoldItalicDetection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonBoldItalicDetection(true);

		// If we are not actively in a text comaprison, update the text comparison bold italic detection.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonBoldItalicDetection").val(g_oSettings.g_oUserSettings.TextComparisonBoldItalicDetection);
		}
	});

	// Change function for the text comaprison whitespace detection setting.
	$("#setting_TextComparisonWhitespaceDetection").on("change", function () {

		// Update the text comparison whitespace detection.
		g_oSettings.g_oUserSettings.TextComparisonWhitespaceDetection = $("#setting_TextComparisonWhitespaceDetection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonWhitespaceDetection(true);

		// If we are not actively in a text comaprison, update the text comparison whitespace detection.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonWhitespaceDetection").val(g_oSettings.g_oUserSettings.TextComparisonWhitespaceDetection);
		}
	});

	// Change function for the text comaprison auto selection setting.
	$("#setting_TextComparisonAutoSelection").on("change", function () {

		// Update the text comparison whitespace detection.
		g_oSettings.g_oUserSettings.TextComparisonAutoSelection = $("#setting_TextComparisonAutoSelection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonAutoSelection(true);

		// If we are not actively in a text comaprison, update the text comparison whitespace detection.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonAutoSelection").val(g_oSettings.g_oUserSettings.TextComparisonAutoSelection);
		}

		// Update the auto select toggle button.
		$("#btnAuto_Select_Toggle_TextCompare")
			.attr("src", g_oSettings.g_oUserSettings.TextComparisonAutoSelection == '2' ? "img/MagicWand_24_Blue.png" : "img/MagicWand_24_Grey.png")
			.tooltipster('content', g_oSettings.g_oUserSettings.TextComparisonAutoSelection == '2' ? g_oTextCompare_AutoSelection.c_szAutoSelectionDisabled : g_oTextCompare_AutoSelection.c_szAutoSelectionEnabled);
	});

	// Change function for the text comaprison accuracy.
	$("#divTextComparisonAccuracy").on("change", function () {

		// Update the text comparison accuracy setting.
		g_oSettings.g_oUserSettings.TextComparisonAccuracy = $("#divTextComparisonAccuracy").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonAccuracy(true);

		// If we are in text compare mode and have not calculated the differences yet, update the settings.
		if (g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Change function for the text comparison sensitivity.
	$("#divTextComparisonCaseSensitivity").on("change", function () {

		// Update the text comparison sensitivity setting.
		g_oSettings.g_oUserSettings.TextComparisonCaseSensitivity = $("#divTextComparisonCaseSensitivity").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonCaseSensitivity(true);

		// If we are in text compare mode and have not calculated the differences yet, update the settings.
		if (g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Change function for the bold italic detection.
	$("#divTextComparisonBoldItalicDetection").on("change", function () {

		// Update the text comparison bold italic detection setting.
		g_oSettings.g_oUserSettings.TextComparisonBoldItalicDetection = $("#divTextComparisonBoldItalicDetection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonBoldItalicDetection(true);

		// If we are in text compare mode and have not calculated the differences yet, update the settings.
		if (g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Change function for the whitespace detection.
	$("#divTextComparisonWhitespaceDetection").on("change", function () {

		// Update the text comparison whitespace detection setting.
		g_oSettings.g_oUserSettings.TextComparisonWhitespaceDetection = $("#divTextComparisonWhitespaceDetection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonWhitespaceDetection(true);

		// If we are in text compare mode and have not calculated the differences yet, update the settings.
		if (g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Change function for the auto selection.
	$("#divTextComparisonAutoSelection").on("change", function () {

		// Update the text comparison whitespace detection setting.
		g_oSettings.g_oUserSettings.TextComparisonAutoSelection = $("#divTextComparisonAutoSelection").val();

		// Update the setting.
		g_oSettings.updateSettingTextComparisonAutoSelection(true);

		// If we are in text compare mode and have not calculated the differences yet, update the settings.
		if (g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.updateTextCompareSettings();
		}
	});

	// Close button pop-up functionality.
	$("#divViewerCell").on("pointerdown", ".closebutton", function (e) {
		e.stopPropagation();
	});

	$("#divViewerCell").on("click", ".closebutton", function (e) {
		e.preventDefault();

		// If the element being closed is an annotation then we're going to remove the div.
		// We'll get it back again if the user clicks on the annotation.
		var szId = $(this).parent().attr("id");
		var iId = g_oAnnotations.getIdFromElementId(szId);

		var result = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id == iId; });

		// Iterate through the annotations and set all children to closed
		var children = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.g_iParentAnnotationId == iId; });
		for (var i = 0; i < children.length; i++) {
			children[i].g_bClosed = true;
		}

		// Get the artwork and annotation canvas based on the speech bubble.
		var oArtworkCanvas = g_oViewer.getCanvas($(this).parent().attr("data-artworkCanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		if (result.length) {
			result[0].g_bClosed = true;
			result[0].g_bSaved = true;

			$("#" + iId).remove();
			if (oArtworkCanvas.g_oDoc.documentType == eDocumentTypes.ThreeD) {
				g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
				oArtworkCanvas.g_oRenderer.render(oArtworkCanvas.g_oScene, oArtworkCanvas.g_oCamera);
			}
			else {
				if (result[0].g_iAnnotationType === eAnnotationTypes.TextMeasurement) {
					g_oTechTools.setTextMeasurementWordVisibility(result[0].g_oTextMeasurementWordsArray, false);
				}

				// If this annotation has an active jqte text box in the list, rebuild the list.
				if ($("#li_" + result[0].id).find(".jqte").length) {
					g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);
				}

				oAnnotationCanvas.redraw(false);
			}

			// Only unhook the pointerdown event if there are no unsaved annotations as they will need it to be able to trigger saveAnnotation function.
			if (!g_oAnnotations.checkForUnsavedAnnotation()) {
				$(document).off("pointerdown");		// Remove the PointerDown event to allow other controls to register click events.
			}
		}
	});

	// Binds the delete button.
	$("#divViewerCell").on("click", ".deletebutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var iId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Find all of the annotations that share the same ID.
		var result = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.id == iId; });
		var relatedResult = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.g_iParentAnnotationId == iId; });

		// Get the artwork and annotation canvas based on the speech bubble.
		var oArtworkCanvas = g_oViewer.getCanvas($(this).parent().attr("data-artworkCanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		// Merge the two arrays together.
		result = result.concat(relatedResult);

		g_oAnnotations.deleteAnnotation(iId, result, false, oArtworkCanvas, oAnnotationCanvas);
		$(document).off("pointerdown");		// Remove the PointerDown event to allow other controls to register click events.

		// Redraw if this is a 2D Canvas.
		if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {
			oAnnotationCanvas.redraw(false);
		}
	});

	$("#divViewerCell").on("click", ".deleteAnnotationReplyButton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var annotationReplyId = parseInt($(this)[0].id.split("_"));

		if (!annotationReplyExists(annotationReplyId)) {
			return;
		}

		// Get the artwork and annotation canvas based on the speechbubble.
		var oArtworkCanvas = g_oViewer.getCanvas($(this).parent().attr("data-artworkCanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		g_oAnnotations.deleteAnnotationReply(annotationReplyId, oArtworkCanvas, oAnnotationCanvas);
		$(document).off("pointerdown");		// Remove the PointerDown event to allow other controls to register click events.
	});

	$("#divViewerCell").on("click", ".cancelAnnotationReplyButton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Hide + remove container.
		var parentContainer = $(".jqte").parent();
		parentContainer.slideUp();
		setTimeout(function () { parentContainer.remove(); }, 400);

		var annotationReplyId = parseInt($(this)[0].id.split("_"));
		var annotation = g_oAnnotations.g_oAnnotationsMade.filter(function (annotation) {
			return annotation.id === annotationReplyId;
		})[0];

		// Aside from this message, nothing else in this annotation can be unsaved - so it is safe to revert to saved state.
		annotation.g_bSaved = true;

		$(".jqte_editor").off("pointermove");
		$(document).off("pointerdown");		// Remove the PointerDown event to allow other controls to register click events.
		changeCanvasFunction();
	});

	/**
	 * Checks to see whether an annotation reply with that ID exists within the approval.
	 * @param {int} annotationReplyId - The annotation reply identifier
	 * @returns {boolean} Does the annotation reply exist?
	 */
	var annotationReplyExists = function (annotationReplyId) {
		return g_oAnnotations.g_oAnnotationsMade.some(function (annotation) {
			return annotation.g_oReplies.some(function (annotationReply) {
				return annotationReply.id === annotationReplyId;
			});
		});
	};

	// Bind the annotation audit button.
	$("#divViewerCell").on("click", ".annotationauditbutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Get the id of the annotation.
		var iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Get the matching annotation.
		var oMatchingAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id === iAnnotationId; })[0];

		// Determine if the annotation is an SVG annotation.
		var bSVGAnnotation = oMatchingAnnotation.g_bSVGTextAnnotation;

		// If the annotation slide out is collapsed, open it.
		if (g_oSettings.g_oUserSettings.LeftMenuCollapse) {

			// Slide the menu to the correct position.
			slideDiv($("#divAnnotationsContainer"), true, true);
		}

		// Get the annotation audit trail.
		g_oAudit.getAnnotationAudit(iAnnotationId, bSVGAnnotation);
	});

	// Bind the close annotation audit button.
	$("#divViewerCell").on("click", ".closeannotationauditbutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Get the id of the annotation.
		var iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Close the annotation audit trail.
		g_oAudit.closeAnnotationAudit(iAnnotationId, true);
	});

	// Bind the annotation data button.
	$("#divViewerCell").on("click", ".annotationdatabutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Get the id of the annotation.
		var iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Get the matching annotation.
		var oMatchingAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id === iAnnotationId; })[0];

		// If the annotation slide out is collapsed, open it.
		if (g_oSettings.g_oUserSettings.LeftMenuCollapse) {

			// Slide the menu to the correct position.
			slideDiv($("#divAnnotationsContainer"), true, true);
		}

		// Get the annotation audit trail.
		g_oAnnotationData.renderAnnotationData(iAnnotationId, oMatchingAnnotation.g_iAnnotationType, oMatchingAnnotation.g_oAnnotationData);
	});

	// Bind the close annotation data button.
	$("#divViewerCell").on("click", ".closeannotationdatabutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Get the id of the annotation.
		var iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Close the annotation data.
		g_oAnnotationData.closeAnnotationData(iAnnotationId, true);
	});

	// Bind the annotation attachments list deletion button to stop default event propagation
	$("#divViewerCell").on("click", ".attachmentDeletionButton", function (e) {
		e.preventDefault();
		e.stopPropagation();
		// Set the id of the annotation.
		g_oAnnotationAttachments.iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);
	});

	// Bind the annotation attachments list deletion button to stop default event propagation
	$("#divViewerCell").on("click", ".attachmentLink", function (e) {
		e.preventDefault();
		e.stopPropagation();
	});

	// Bind the batch clone button.
	$("#divViewerCell").on("click", ".copybatchbutton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var iId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		// Lock the screen.
		lockScreen();

		// Create Server Call for the data.
		var oJSON = {
			szSessionId: g_szSessionId,
			iAnnotationId: iId
		};

		// Clone.
		$.post({
			url: "internal/GreenlightAnnotation/CopyBatchAnnotations",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				if (oResponse.Success) {
					g_oGreenlightMessages.displaySuccessBubble(g_oMultiView.c_szCopyAnnotationSuccess);
					// Add the annotations to be blocked from copy.
					g_oMultiView.copiedAnnotationIds = $.merge(g_oMultiView.copiedAnnotationIds, JSON.parse(oResponse.Contents).AnnotationIds);
					// Hide the current annotation used.
					$("input[id=" + iId + "_batchAdd]").hide();

				} else {
					g_oGreenlightMessages.displayErrorBubble(displayErrorContentHTML(oResponse.Errors));
				}
			}
		})
			.always(function () {
				unlockScreen();
				$(document).off("pointerdown");	// Remove the PointerDown event to allow other controls to register click events.
			});
	});

	// Renders an annotation bubble on the canvas when clicked.
	$("#divViewerCell").on("click", ".annotationListItem", function (e) {

		e.preventDefault();

		// Highlight the annotation list item.
		$(".annotationListItem").removeClass("annotationListItemSelected");
		$(this).addClass("annotationListItemSelected");

		// Get the artwork and annotation canvas based on the speech bubble.
		var oArtworkCanvas = g_oViewer.getCanvas($(this).attr("data-artworkCanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

		// Get the sync canvases
		var oSyncCanvas = g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer);

		for (var sync in oSyncCanvas) {
			if (oSyncCanvas[sync] == oArtworkCanvas) {
				// Annotation is on the compare viewer, so the sync canvas should be the original artwork viewer
				oSyncCanvas[sync] = g_oViewer.g_oArtworkViewer;
			}
		}


		// Find the annotation we have just clicked on.
		var id = $(this).attr("id");
		id = id.substring(3);

		// Get the matching annotation.
		var oMatchingAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.id == id; });

		// If the matching annotation has been found.
		if (oMatchingAnnotation.length > 0) {

			// If this is a text measurement with no words.
			if (oMatchingAnnotation[0].g_iAnnotationType === eAnnotationTypes.TextMeasurement &&
				oMatchingAnnotation[0].g_oTextMeasurementWordsArray.length === 0) {
				var oData = {
					oAnnotation: oMatchingAnnotation[0],
					oArtworkCanvas: oArtworkCanvas,
					oAnnotationCanvas: oAnnotationCanvas
				};
				EventService.publish("getTextMeasurementText", oData);
			}

			var existingAnnotationDivs = $("#" + id);
			if (!$(existingAnnotationDivs).hasClass("speechbubble")) {
				if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {
					oMatchingAnnotation[0].createAnnotationDiv(eAnnotationDivType.Popup, true, null, oArtworkCanvas, oAnnotationCanvas);
					oMatchingAnnotation[0].panToAnnotation(oArtworkCanvas, oAnnotationCanvas, oSyncCanvas);

					if (oMatchingAnnotation[0].g_iAnnotationType === eAnnotationTypes.TextMeasurement) {
						g_oTechTools.setTextMeasurementWordVisibility(oMatchingAnnotation[0].g_oTextMeasurementWordsArray, true);
					}

					oMatchingAnnotation[0].g_bClosed = false;
					oAnnotationCanvas.redraw(false);
				}
				else {
					// If its a 3d artwork.
					oMatchingAnnotation[0].createAnnotationDiv(eAnnotationDivType.Popup, 1, [400, 100], oArtworkCanvas, oAnnotationCanvas);

					// Setup the camera to point to the annotation. This will move the 3D image to show the annotation on screen.
					var markup = $.grep(oArtworkCanvas.g_oScene.children, function (child) { return child.Id == id; });
					// Reset colour on each annotation mark-up
					g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
					// Then highlight the selected mark-up
					if (markup.length) {
						oArtworkCanvas.g_oCamera.lookAt(markup[0].position);
						var newZPosition;
						if (markup[0].position.z < 0) {
							newZPosition = markup[0].position.z - 0.15;
						} else {
							newZPosition = markup[0].position.z + 0.15;
						}
						oArtworkCanvas.g_oCamera.position.set(markup[0].position.x, markup[0].position.y, newZPosition);
					}
				}
			}
			// Otherwise, if this is not a threeD document.
			else if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {

				// Pan to the annotation.
				oMatchingAnnotation[0].panToAnnotation(oArtworkCanvas, oAnnotationCanvas, oSyncCanvas);
			}
		}

		e.stopPropagation();
	});

	// Bind the annotation attachment icon on click.
	$("#divViewerCell").on("click", ".annotationattachmentbutton", function (e) {

		e.preventDefault();
		e.stopPropagation();

		// Get the id of the annotation.
		var iAnnotationId = g_oAnnotations.getIdFromElementId($(this)[0].id);

		g_oAnnotationAttachments.iAnnotationId = iAnnotationId;
		g_oAnnotationAttachments.renderPopupAttachments(iAnnotationId);

		g_oAnnotationAttachments.displayUploadPopUp();
	});

	// Bind the annotation attachment close icon on click.
	$('#divCloseUploadOverlay').click(function () {
		g_oAnnotationAttachments.iAnnotationId = null;
		hidePopupWindow("divUploadOverlay");
	});

	// Updates/set an annotation status.
	$("#divViewerCell").on("click", ".addStatusButton", function (e) {
		e.preventDefault();
		e.stopPropagation();

		// Close any open annotation color pallets.
		Annotation.prototype.RemoveLastColourSelection();

		// Work out the id of the annotation we have clicked on.
		var szIsListItemPrefix = "";
		var id = $(this).parent().attr("id");
		if (id.indexOf("li_") !== -1) {
			id = id.substring(3);
			szIsListItemPrefix = "li_";
		}

		// Get the clicked annotations status.
		var szStatus = this.getAttribute("data-annotationstatus");

		// Get the status code from the status.
		var iStatusCode = 0;
		switch (szStatus) {
			case "Approved":
				iStatusCode = eAnnotationStatuses.Approved;
				break;
			case "Rejected":
				iStatusCode = eAnnotationStatuses.Rejected;
				break;
			case "Query":
				iStatusCode = eAnnotationStatuses.Query;
				break;
			case "ToDo":
				iStatusCode = eAnnotationStatuses.ToDo;
				break;
		}
		
		// Determine the canvas to used for rendering based on the annotation.
		var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		// Find the matching Annotation.
		var oMatchingAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id == id; });

		// If the annotation audit trail is open, close the annotation audit trail.
		if ($("#" + oMatchingAnnotation[0].id + "_annotationAuditContainer").css("display") != "none") {
			g_oAudit.closeAnnotationAudit(oMatchingAnnotation[0].id, false);
		}

		// Has the author already left an existing status on the annotation.
		var iExistingStatus = $.grep(oMatchingAnnotation[0].g_oStatuses, function (status) { return status.g_iAuthor == g_oUserDetails.UserId; });

		// If this is an unlocked annotation, all users share the same annotation status.
		if (oMatchingAnnotation[0].g_bUnlocked) {
			iExistingStatus = oMatchingAnnotation[0].g_oStatuses;
		}

		// We should work out what annotation status change action to perform.
		var iStatusChangeAction = g_oAnnotations.setAnnotationStatusUpdateAction(iExistingStatus, iStatusCode);

		// Process the annotation status action.
		switch (iStatusChangeAction) {
			case eAnnotationStatusUpdateType.addStatus:

				// There is no status, we need to create the status text area and create a new Annotation Status object.
				var oNewAnnotationStatus = g_oAnnotations.createAnnotationStatus();
				oNewAnnotationStatus.g_iApprovalUserAnnotId = oMatchingAnnotation[0].id;
				oNewAnnotationStatus.g_iAuthor = g_oUserDetails.UserId;
				oNewAnnotationStatus.g_szAuthorEmail = g_oUserDetails.EmailAddress;
				oNewAnnotationStatus.g_iAnnotationStatus = iStatusCode;
				oNewAnnotationStatus.annotationStatusDateTime = Date.now();

				// Update any list items.
				szIsListItemPrefix = "li_";
				var statusContainerId = "sc_" + szIsListItemPrefix + oMatchingAnnotation[0].id;
				oMatchingAnnotation[0].createAnnotationTextArea("st_" + oMatchingAnnotation[0].id, oNewAnnotationStatus.g_iAuthor, g_oUserDetails.EmailAddress, "", 2, true, szStatus, document.getElementById(statusContainerId), Date.now(), null, oArtworkCanvas);

				// Update any pop-up if it exists.
				var statusContainerListId = "sc_" + oMatchingAnnotation[0].id;
				oMatchingAnnotation[0].createAnnotationTextArea("st_" + oMatchingAnnotation[0].id, oNewAnnotationStatus.g_iAuthor, g_oUserDetails.EmailAddress, "", 2, true, szStatus, document.getElementById(statusContainerListId), Date.now(), null, oArtworkCanvas);

				// Push the new status to the annotation.
				oMatchingAnnotation[0].g_oStatuses.push(oNewAnnotationStatus);
				break;

			case eAnnotationStatusUpdateType.updateStatus:

				// Keep track of the original and new author of the annotation.
				var iOriginalAuthorId = iExistingStatus[0].g_iAuthor;
				var iNewAuthorId = g_oUserDetails.UserId;

				// Update the details of the annotation status.
				iExistingStatus[0].g_iAnnotationStatus = iStatusCode;
				iExistingStatus[0].g_iAuthor = iNewAuthorId;
				iExistingStatus[0].g_szAuthorEmail = g_oUserDetails.EmailAddress;
				iExistingStatus[0].annotationStatusDateTime = Date.now();

				// Find the pop-up and update the status value and author.
				var relatedPopups = $("#" + oMatchingAnnotation[0].id).find("[data-statusfield=\"statusValue\"]" + "[data-authorid =\"" + iOriginalAuthorId + "\"]");
				if (relatedPopups.length !== 0) {
					relatedPopups[0].textContent = szStatus;
					relatedPopups[0].setAttribute("data-authorid", iNewAuthorId);
					if (relatedPopups.prev(".HeaderTextStatus").children("[data-statusfield=\"statusAuthor\"]").length !== 0) {
						relatedPopups.prev(".HeaderTextStatus").children("[data-statusfield=\"statusAuthor\"]")[0].textContent = g_oAnnotations.getDisplayName(g_oUserDetails.EmailAddress, "") + " " + formatDate(iExistingStatus[0].annotationStatusDateTime);
					}
				}

				// Find the list item and update the status value and author.
				var relatedAnnotationListItems = $("#li_" + oMatchingAnnotation[0].id).find("[data-statusfield=\"statusValue\"]" + "[data-authorid =\"" + iOriginalAuthorId + "\"]");
				if (relatedAnnotationListItems.length !== 0) {
					relatedAnnotationListItems[0].textContent = szStatus;
					relatedAnnotationListItems[0].setAttribute("data-authorid", iNewAuthorId);
					if (relatedAnnotationListItems.prev(".HeaderTextStatus").children("[data-statusfield=\"statusAuthor\"]").length !== 0) {
						relatedAnnotationListItems.prev(".HeaderTextStatus").children("[data-statusfield=\"statusAuthor\"]")[0].textContent = g_oAnnotations.getDisplayName(g_oUserDetails.EmailAddress, "") + " " + formatDate(iExistingStatus[0].annotationStatusDateTime);
					}
				}
				break;
		}
		
		// Save directly.
		if (g_szSessionId !== 0 && g_oAnnotations.g_iApprovalId === oMatchingAnnotation[0].g_iApprovalId) {

			// If we are updating an existing status.
			if (iExistingStatus.length && iStatusChangeAction !== eAnnotationStatusUpdateType.deleteStatus) {

				// Update the existing status.
				iExistingStatus[0].annotationSaveStatus(oMatchingAnnotation[0]);
			}
			// If we are removing a status.
			else if (iExistingStatus.length && iStatusChangeAction === eAnnotationStatusUpdateType.deleteStatus) {
				iExistingStatus[0].deleteAnnotationStatus(oMatchingAnnotation[0], iExistingStatus[0].id, oArtworkCanvas, oAnnotationCanvas, true, true, true);
			}
			// If we are adding a new status.
			else {
				oNewAnnotationStatus.annotationSaveStatus(oMatchingAnnotation[0]);
			}
			
			// Update the status icons.
			$(".Approved_statusGroup_" + id).attr("src", (iStatusCode == eAnnotationStatuses.Approved && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? "img/Status_Approved_Inverted_16.svg" : "img/Status_Approved_White_16.svg"));
			$(".Rejected_statusGroup_" + id).attr("src", (iStatusCode == eAnnotationStatuses.Rejected && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? "img/Status_Rejected_Inverted_16.svg" : "img/Status_Rejected_White_16.svg"));
			$(".Query_statusGroup_" + id).attr("src", (iStatusCode == eAnnotationStatuses.Query && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? "img/Status_Query_Inverted_16.svg" : "img/Status_Query_White_16.svg"));
			$(".ToDo_statusGroup_" + id).attr("src", (iStatusCode == eAnnotationStatuses.ToDo && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? "img/Status_ToDo_Inverted_16.svg" : "img/Status_ToDo_White_16.svg"));

			// Update the status icon tooltips.
			Annotation.prototype.renderAnnotationStatusTooltips(id, iStatusCode, iStatusChangeAction);

			// Scroll to the updated status icons in the list.
			Annotation.prototype.ScrollStatusAnnotationList(oMatchingAnnotation[0]);
		}
	});

	/**
	* Step through functions.
	*/

	// Bind the step through function.
	$("#imgStepThroughAnnotations").on("click", function (e) {
		g_oAnnotations.stepThroughAnnotations(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
	});

	// Show Annotation Numbers.
	$("#btnShowAnnNumbers, #settings_ShowAnnotationNumbersToggle").on("click", function (e) {
		
		// If the annotation numbers are currently hidden.
		if (!g_oSettings.g_oUserSettings.ShowAnnotationNumbers) {

			// Set that the numbers should be shown.
			g_oSettings.g_oUserSettings.ShowAnnotationNumbers = true;

			// Fade in the annotation numbers in the list.
			$(".annNumber").fadeIn(500);
		}
		// If the annotation numbers are currently shown.
		else {

			// Set that the numbers should be hidden.
			g_oSettings.g_oUserSettings.ShowAnnotationNumbers = false;

			// Fade out the annotation numbers in the list.
			$(".annNumber").fadeOut(500);
		}

		// Update the setting.
		g_oSettings.updateSettingShowAnnotationNumbers(true);

		// Determine the canvas to used for rendering based on the annotation toggle.
		var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		// If this is not a threeD document.
		if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {

			// Redraw the annotations with the show number setting updated.
			oAnnotationCanvas.redraw(false);
		}
		// If this is a threeD document.
		else {

			// Redraw the threeD annotations with the show number setting updated.
			g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
		}
	});

	// Print Annotations.
	$("#btnPrintAnnotations").on("click", function (e) {

		// Determine the approval id based on the annotation toggle.
		var bUseCompareApproval = $("#chkAnnotationToggle").prop("checked");

		// Determine the number of documents with approvals.
		var oDocs = comboControl_GetControlById("approvalNameComboControl", false).documents;

		// Hacky way of checking for versions. If it's got an approval & it was put in the database before this approval,
		// it's probably a previous version.
		var oDocumentsInApproval = $.grep(oDocs, function (document) {
			return document.greenlightApprovalId > 0 && document.greenlightApprovalId < oDocs[g_oaComboControls[0].selectedDocumentIndex].greenlightApprovalId;
		});

		// If there are other documents with approvals.
		if (oDocumentsInApproval.length > 0) {

			// Create the confirmation option.
			var oConfirmAction = function () {
				g_oApproval.CreateAnnotationsReport(bUseCompareApproval, true, oDocs);
			};

			// Create the rejection option.
			var oRejectionAction = function () {
				g_oApproval.CreateAnnotationsReport(bUseCompareApproval, false, oDocs);
			};

			// Display a confirmation message to check if other documents should be included in the report.
			g_oGreenlightMessages.displayConfirmBubble("Include previous approval versions in the document?", oConfirmAction, oRejectionAction);
		}
		// If there are no other documents with approvals.
		else {

			// Create the annotation report with the current document only.
			g_oApproval.CreateAnnotationsReport(bUseCompareApproval, false, oDocs);
		}
	});

	/**
	* Annotation Filtering
	*/

	$("#divFilterAnnotations").on("click", function (e) {

		// Toggle the filters section.
		g_oFilter.toggleAnnotationFilters();
	});

	$("#divViewerCell").on("focus", "#txtAnnListFilterBox", function (e) {

		// If we have a value.
		if (this.value.trim().length === 0) {

			// Reset the filter box.
			g_oFilter.resetFilterOptions("divAnnListFilterBox");
		}
		else {

			// Update the filter box.
			g_oFilter.updateFilterOptions("divAnnListFilterBox", this.value.toLowerCase());
		}

		// Show the filter options dropdown.
		$("#divAnnListFilterBox").show();
	});

	$("#divViewerCell").on("keyup", "#txtAnnListFilterBox", function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		// Show the filter options dropdown.
		$("#divAnnListFilterBox").show();

		// If this is the enter key.
		if (e.which === 13) {

			// Click the filter option.
			g_oFilter.clickFilterOption();
		}
		// If this is the down arrow.
		else if (e.which === 40) {

			// Select the next filter option.
			g_oFilter.selectNextFilterOption();
		}
		// If this is the up arrow.
		else if (e.which === 38) {

			// Select the previous filter option.
			g_oFilter.selectPreviousFilterOption();
		}
		// If we have a no value.
		else if (this.value.trim().length === 0) {

			// Reset the filter box.
			g_oFilter.resetFilterOptions("divAnnListFilterBox");
		}
		// If the string has live test.
		else if (this.value.match("<(.|\n)*?>")) {

			// Remove the value.
			this.value = "";

			// Reset the filter box.
			g_oFilter.resetFilterOptions("divAnnListFilterBox");

			// Display a warning to indicate this cannot be used to filter.
			g_oGreenlightMessages.displayWarningBubble(g_oFilter.c_szFilter_Message_UnableToFilter);
		}
		// We have a valid value.
		else {

			// Update the filter box.
			g_oFilter.updateFilterOptions("divAnnListFilterBox", this.value.toLowerCase());
		}
	});

	$("#imgFilterReset").on("click", function (e) {
		
		// Reset the filters.
		g_oFilter.resetActiveFilters();
	});

	/**
	* SVG Filtering
	*/

	$("#divToolBar").on("focus", "#txtSVGTextSearch", function (e) {
		$(this).animate({ width: "95%" });
		e.preventDefault();
		e.stopPropagation();
	});

	$("#divToolBar").on("blur", "#txtSVGTextSearch", function (e) {
		$(this).animate({ width: "50%" });
		e.preventDefault();
		e.stopPropagation();
	});

	$("#divToolBar").on("keyup", "#txtSVGTextSearch", function (e) {

		// Get the content of the SVG search box.
		var szSearchContent = $("#txtSVGTextSearch").val();

		// Determine the canvas to used for rendering based on the annotation toggle.
		var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		// If this is the enter key.
		if (e.which === 13) {

			// Run the SVG text search.
			g_oSVGSearch.searchSVGText(szSearchContent, oArtworkCanvas, oAnnotationCanvas);
		}
		// If there is no text in the search content.
		else if (szSearchContent.length === 0) {

			// Remove any existing SVG search annotations.
			g_oSVGText.removeSVGSearchAnnotations(oArtworkCanvas, oAnnotationCanvas, true);
		}
	});

	$("#btnSVGFindText").on("click", function (e) {

		// Toggle the active state of finding SVG text.
		g_oViewer.c_bFindSVGText = !g_oViewer.c_bFindSVGText;

		// If we are now finding SVG text.
		if (g_oViewer.c_bFindSVGText) {

			// Reshow annotations if they are hidden.
			if (!g_oSettings.g_oUserSettings.ShowAnnotations) {
				$("#HideAnnotations").click();
			}

			// Highlight the find SVG text icon.
			$("#btnSVGFindText").addClass("selectedButton");
		}
		// If we are no longer finding SVG text.
		else {

			// Determine the canvas to used for rendering based on the annotation toggle.
			var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
			var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

			// Remove any existing hover annotations.
			g_oSVGText.removeSVGHoverAnnotations(oArtworkCanvas, oAnnotationCanvas, true);

			// Clear the SVG search.
			g_oSVGSearch.clearSVGSearch(oArtworkCanvas, oAnnotationCanvas, true);

			// Un-highlight the find SVG text icon.
			$("#btnSVGFindText").removeClass("selectedButton");
		}
	});

	$("#btnSVGTextSearch").on("click", function (e) {

		// Get the content of the SVG search box.
		var szSearchContent = $("#txtSVGTextSearch").val();

		// Determine the canvas to used for rendering based on the annotation toggle.
		var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		// Run the SVG text search.
		g_oSVGSearch.searchSVGText(szSearchContent, oArtworkCanvas, oAnnotationCanvas);
	});

	/**
	 * Zoom slider.
	 */
	$("#divNavSlider_Range").on("change", function () {
		g_oViewer.g_oArtworkViewer.g_oCanvasZoom.zoomSlide(parseInt(this.value));
	});

	/************************** 3D Tools ****************************/


	$('#closeThreeDPreviewOptions').click(function () {
		hidePopupWindow("divModalOverlay");
	});

	$('#txtThreeDViewer_Existing_Filter').on('input', function () {
		g_oThreeDView.RenderThreeDViews($('#txtThreeDViewer_Existing_Filter').val().toLowerCase());
	});

	$('#txtThreeDViewer_Model_Filter').on('input', function () {
		g_oThreeDView.RenderModels($('#txtThreeDViewer_Model_Filter').val().toLowerCase());
	});

	$('#divThreeDViewExpansion').click(function () {
		var szThreeDControlDownArrow = g_oSettings.c_iSkinType === 0 ? "img/Arrow_Down_White_16.png" : "img/Arrow_Down_16.png";
		var szThreeDControlRightArrow = g_oSettings.c_iSkinType === 0 ? "img/Arrow_Right_White_16.png" : "img/Arrow_Right_16.png";

		// If shown, hide
		if ($('#tblThreeDViewImagePlaceHolders').is(":visible")) {
			$('#imgExpandThreeDviews').attr('src', szThreeDControlRightArrow);
			$('#tblThreeDViewImagePlaceHolders').hide();
		}
		else {// If hidden, show
			$('#imgExpandThreeDviews').attr('src', szThreeDControlDownArrow);
			$('#tblThreeDViewImagePlaceHolders').show();
		}
	});

	$('#divModelExpansion').click(function () {
		var szThreeDControlDownArrow = g_oSettings.c_iSkinType === 0 ? "img/Arrow_Down_White_16.png" : "img/Arrow_Down_16.png";
		var szThreeDControlRightArrow = g_oSettings.c_iSkinType === 0 ? "img/Arrow_Right_White_16.png" : "img/Arrow_Right_16.png";

		// If shown, hide
		if ($('#tblModelImagePlaceHolders').is(":visible")) {
			$('#imgExpandModels').attr('src', szThreeDControlRightArrow);
			$('#tblModelImagePlaceHolders').hide();
		}
		else {// If hidden, show
			$('#imgExpandModels').attr('src', szThreeDControlDownArrow);
			$('#tblModelImagePlaceHolders').show();
		}
	});


	/************************** Technical Tools ****************************/

	/**
	* Technical Tools Menu
	*/

	$("#btnTechTools").click(function () {

		// If we have an active text highlight, prevent the drop down.
		if (g_oTextTools.g_bHighlightInProgress) {
			return;
		}

		var thisParent = $(this).parent();
		var bOpen = thisParent.find(".dropdown-content").is(":visible");
		highlightButtonClearingAllIcons(thisParent, true);
		if (!bOpen) {
			$("#divTechToolsDropDown").slideToggle(200);
			g_oSavedCalipers.SelectivelyShowCaliperFlexArrows();
		}
		else {
			clearHighlightSelectedButton(thisParent);
		}
	});

	$("#divTechToolsPointToPoint").on("click", function (e) {
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.POINTTOPOINT);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			g_oMarquee.initiateMarqueeDraw(event,										            	// The triggering event.
				eAnnotationTypes.PointToPointMeasurement,					// The type of marquee that is to be drawn.
				g_oViewer.getCanvas(event.currentTarget.id),				// The Annotation Viewer on which the marquee is drawn.
				g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id),	// The Artwork Viewer which contains the dimensions the marquee is to work against.
				null,														// The canvas to sync any marquee actions to.
				g_oTechTools.measurementMarqueeDraw,						// The function to be called when the 'pointermove' event is called.
				g_oTechTools.measurementPointerUp,							// The function to be called when the 'pointerup' event is called.
				true,														// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
				false,														// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
				null,														// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
				false);														// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsArea").on("click", function (e) {
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.AREA);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
				eAnnotationTypes.AreaMeasurement,		// The type of marquee that is to be drawn.
				g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
				g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
				null,										// The canvas to sync any marquee actions to.
				g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
				g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
				true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
				false,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
				null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
				false);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsHorizontal").on("click", function (e) {
		g_oSavedCalipers.CaliperMeasurementOptionHover(g_oTechTools.g_eMeasurementTypes.HORIZONTAL);
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.HORIZONTAL);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			$("#divTechToolsDropDown").slideUp(200);
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
				eAnnotationTypes.HorizontalCalliperMeasurement,	// The type of marquee that is to be drawn.
				g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
				g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
				null,										// The canvas to sync any marquee actions to.
				g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
				g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
				true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
				false,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
				null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
				false);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsVertical").on("click", function (e) {
		g_oSavedCalipers.CaliperMeasurementOptionHover(g_oTechTools.g_eMeasurementTypes.VERTICAL);
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.VERTICAL);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			$("#divTechToolsDropDown").slideUp(200);
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
				eAnnotationTypes.VerticalCalliperMeasurement,	// The type of marquee that is to be drawn.
				g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
				g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
				null,										// The canvas to sync any marquee actions to.
				g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
				g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
				true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
				false,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
				null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
				false);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsHorizontal").hover(function () {
		g_oSavedCalipers.CaliperMeasurementOptionHover(g_oTechTools.g_eMeasurementTypes.HORIZONTAL);
	}, function (e) {
			g_oSavedCalipers.CaliperMeasurementOptionHoverLeave(e);
	});

	$("#techToolsDrodown").hover(function () { }, function (e) {
		g_oSavedCalipers.TechToolsHoverLeave(e);
	});

	$("#divTechToolsDropDown").hover(function () { }, function (e) {
		g_oSavedCalipers.CaliperMeasurementOptionHoverLeave(e);
	});

	$(".techToolType").hover(function () {
		var szId = GetElementId(this);
		if (szId !== "divTechToolsHorizontal" && szId !== "divTechToolsVertical") {
			g_oSavedCalipers.ClearSavedMeasurementsDiv();
		}
	});

	$("#divTechToolsVertical").hover(function () {
		g_oSavedCalipers.CaliperMeasurementOptionHover(g_oTechTools.g_eMeasurementTypes.VERTICAL);
	}, function (e) {
			g_oSavedCalipers.CaliperMeasurementOptionHoverLeave(e);
	});

	$("#divTechToolsBarcode").on("click", function (e) {
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.BARCODE);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
											eAnnotationTypes.BarcodeMeasurement,	// The type of marquee that is to be drawn.
											g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
											g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
											null,										// The canvas to sync any marquee actions to.
											g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
											g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
											true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
											false,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
											null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
											false);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsDensity").on("click", function (e) {
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.COLOURDENSITY);
		$(".annotationViewer").off("click");
		$(".annotationViewer").off("pointerup");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
											eAnnotationTypes.ColourDensityMeasurement,	// The type of marquee that is to be drawn.
											g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
											g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
											null,										// The canvas to sync any marquee actions to.
											g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
											g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
											true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
											true,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
											null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
											true);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	$("#divTechToolsText").on("click", function (e) {
		g_oTechTools.toolTypeChange(this, g_oTechTools.g_eMeasurementTypes.TEXT);
		$(".annotationViewer").off("pointerup");
		$(".annotationViewer").off("click");
		changeCanvasFunction(".annotationViewer", "pointerdown", function (event) {

			// Ensure the annotation document is toggled to this document.
			g_oCompare.forceToggleAnnotationDocument(event.currentTarget.id);

			// Initiate the draw.
			g_oMarquee.initiateMarqueeDraw(event,									// The triggering event.
											eAnnotationTypes.TextMeasurement,		// The type of marquee that is to be drawn.
											g_oViewer.getCanvas(event.currentTarget.id), // The Annotation Viewer on which the marquee is drawn.
											g_oViewer.getLinkedArtworkCanvas(event.currentTarget.id), // The Artwork Viewer which contains the dimensions the marquee is to work against.
											null,										// The canvas to sync any marquee actions to.
											g_oTechTools.measurementMarqueeDraw,	// The function to be called when the 'pointermove' event is called.
											g_oTechTools.measurementPointerUp,		// The function to be called when the 'pointerup' event is called.
											true,									// An optional condition to be met for the marquee to be drawn. Pass TRUE is the condition is not required.
											true,									// An optional override to allow point selections as well as click and drag selections. Pass FALSE if the override is not required.
											null,									// An object to pass in line width and line colour if a box-style marquee is to be drawn instead of an overlay marquee. Pass NULL if an overlay marquee is required.
											true);									// Indicate if the marquee should always be initiated without checking criteria.
		});
	});

	// Click event for the annotation text highlight and text classification.
	$("#TextHighlight, #TextClassification").on("click", function (e) {

		// Slide up the annotations drop down.
		$("#annotationDropDown").slideUp(200);

		// Clear the last used annotation tool type.
		g_oAnnotations.g_oLastUsedTool = "";

		// Set the annotation type to be used.
		var eAnnotationCreationType = e.target.id == "TextClassification" || e.target.parentElement.id == "TextClassification" ? eAnnotationTypes.TextClassification : eAnnotationTypes.TextHighlight;

		// Initialise the highlight once the data has been loaded.
		var oCallbackAction = function () {

			// Set that this will be a new annotation.
			g_oTextTools.g_iExistingAnnotationId = null;

			// Set up the new annotation text.
			g_oTextTools.g_oAnnotationText = [];

			// Initialise the highlight.
			g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.TextHighlight, eAnnotationCreationType, true, false, g_oAnnotations.g_oAnnotationColSelected);
		};

		// Load the text data for the file.
		g_oTextData.loadTextData(g_oViewer.g_oArtworkViewer.g_oDoc.documentId, g_oViewer.g_oArtworkViewer.g_iCurrentPage, true, oCallbackAction);
	});

	// Updates the measurement preference when an option is selected in the settings dropdown.
	$("#settings_MeasurementPreference").on("change", function (event) {

		// If the value is now different to our current measurement preference.
		if ($("#settings_MeasurementPreference").val() !== g_oSettings.g_oUserSettings.UseMetricUnits) {

			// Prevent the next click from closing the settings menu.
			g_oSettings.g_bIgnoreNextClickEvent = true;

			// Toggle the units.
			$("#divTechToolsUnits").click();
		}
	});

	// Updates the measurement preference when an option is selected in the settings dropdown.
	$("#setting_SkinType").on("change", function (event) {
		
		// Update the select skin type.
		g_oSettings.g_oUserSettings.SkinType = $("#setting_SkinType").val();

		// Update the setting.
		g_oSettings.updateSettingSkinType(true);
	});

	// Updates the date format when an option is selected in the settings dropdown.
	$("#setting_DateFormat").on("change", function (event) {

		// Update the date format.
		g_oSettings.g_oUserSettings.DateFormat = $("#setting_DateFormat").val();

		// Update the setting.
		g_oSettings.updateSettingDateFormat(true);
	});

	// Updates the measurement preference when an option is toggled.
	$("#divTechToolsUnits, #OffsetUnitsImg, #AlignmentUnitsImg_Viewer, #AlignmentUnitsImg_Compare, #GuidedUnitsImg_Compare").on("click", function (event) {
		
		// Outline the required variables.
		var oCompareOffsetPixels = null;
		var oAlignmentOffsetPixels_Viewer = null;
		var oAlignmentOffsetPixels_Compare = null;
		var oAlignmentOffsetPixels_Saved = null;
		var oAlignmentGuidencePixels_Tolerance = null;

		// If the compare module has been loaded.
		if (typeof (g_oCompare.convertMeasurementToPixels) != "undefined") {

			// Extract each of the compare offset values as pixels.
			oCompareOffsetPixels = g_oCompare.convertMeasurementToPixels($("#CompareOffsetX").val(), $("#CompareOffsetY").val(), g_oCompare.g_oArtworkViewer, false);
			oAlignmentOffsetPixels_Viewer = g_oCompare.convertMeasurementToPixels($("#AlignmentX_Viewer").val(), $("#AlignmentY_Viewer").val(), g_oCompare.g_oArtworkViewer, false);
			oAlignmentOffsetPixels_Compare = g_oCompare.convertMeasurementToPixels($("#AlignmentX_Compare").val(), $("#AlignmentY_Compare").val(), g_oCompare.g_oArtworkViewer, false);
			oAlignmentOffsetPixels_Saved = g_oCompare.convertMeasurementToPixels(g_oCompare.g_oAlignment_SavedCompareOffsetX, g_oCompare.g_oAlignment_SavedCompareOffsetY, g_oCompare.g_oArtworkViewer, false);
			oAlignmentGuidencePixels_Tolerance = g_oCompare.convertMeasurementToPixels($("#GuidedTolerance").val(), $("#GuidedTolerance").val(), g_oCompare.g_oArtworkViewer, false);
		}

		// Update the measurement unit.
		g_oSettings.g_oUserSettings.UseMetricUnits = !g_oSettings.g_oUserSettings.UseMetricUnits;

		// If the compare module has been loaded.
		if (typeof (g_oCompare.convertPixelsToMeasurement) != "undefined") {

			// Convert each of the compare offset values to the new measurement.
			var oCompareOffsetMeasurement = g_oCompare.convertPixelsToMeasurement(oCompareOffsetPixels.x, oCompareOffsetPixels.y, g_oCompare.g_oArtworkViewer);
			var oAlignmentOffsetMeasurement_Viewer = g_oCompare.convertPixelsToMeasurement(oAlignmentOffsetPixels_Viewer.x, oAlignmentOffsetPixels_Viewer.y, g_oCompare.g_oArtworkViewer);
			var oAlignmentOffsetMeasurement_Compare = g_oCompare.convertPixelsToMeasurement(oAlignmentOffsetPixels_Compare.x, oAlignmentOffsetPixels_Compare.y, g_oCompare.g_oArtworkViewer);
			var oAlignmentOffsetMeasurement_Saved = g_oCompare.convertPixelsToMeasurement(oAlignmentOffsetPixels_Saved.x, oAlignmentOffsetPixels_Saved.y, g_oCompare.g_oArtworkViewer);
			var oAlignmentGuidenceMeasurement_Tolerance = g_oCompare.convertPixelsToMeasurement(oAlignmentGuidencePixels_Tolerance.x, oAlignmentGuidencePixels_Tolerance.y, g_oCompare.g_oArtworkViewer);

			// Set each of the compare offset values to be the new measurement.
			$("#CompareOffsetX").val(oCompareOffsetMeasurement.x);
			$("#CompareOffsetY").val(oCompareOffsetMeasurement.y);
			$("#AlignmentX_Viewer").val(oAlignmentOffsetMeasurement_Viewer.x);
			$("#AlignmentY_Viewer").val(oAlignmentOffsetMeasurement_Viewer.y);
			$("#AlignmentX_Compare").val(oAlignmentOffsetMeasurement_Compare.x);
			$("#AlignmentY_Compare").val(oAlignmentOffsetMeasurement_Compare.y);
			g_oCompare.g_oAlignment_SavedCompareOffsetX = oAlignmentOffsetMeasurement_Saved.x;
			g_oCompare.g_oAlignment_SavedCompareOffsetY = oAlignmentOffsetMeasurement_Saved.y;
			$("#GuidedTolerance").val(oAlignmentGuidenceMeasurement_Tolerance.x);
		}

		// Update the setting.
		g_oSettings.updateSettingMeasurementPreference(true);
	});

	$("#divTechToolsClearCanvas").on("click", function (e) {
		g_oTechTools.clearToolType();
		g_oTechTools.g_oAnnotationViewer.redraw(false);
		if (g_oViewer.g_oCompareMode != eCompareMode.NoCompare) {
			g_oCompare.g_oCompareAnnotationViewer.redraw(false);
			if (g_oViewer.g_oCompareMode == eCompareMode.SideBySideDiff) {
				g_oCompare.g_oDifferencesAnnotationViewer.redraw(false);
			}
		}
		$(g_oSeparations.SpinnerElementName).hide();
		$(g_oTechTools.c_szSeparationPercentageElementName).hide();
		$(g_oTechTools.c_szSeparationPercentage_BarcodeElementName).hide();
		$("#td_TAC").hide();
	});

	/************************** Compare ****************************/

	$("#OverlayToleranceSlider").on("pointerup", function (event) {
		g_oCompare.updateTolerance();
	});

	$("#OverlayGhostingSlider").on("pointerup", function (event) {
		g_oCompare.updateGhosting();
	});

	$("#BlinkSpeedSlider, #DiffSpeedSlider").on("pointerup", function (event) {
		// Get the slider value and assign.
		g_oCompare.updateBlinkSpeed(parseInt($(this).val()));
	});

	// Toggle the annotation canvas.
	$("#chkAnnotationToggle").click(function () {

		// If we are currently finding SVG text.
		if (g_oViewer.c_bFindSVGText) {

			// Determine the canvas to used for rendering based on the annotation toggle.
			var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
			var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

			// Remove any existing hover annotations.
			g_oSVGText.removeSVGHoverAnnotations(oArtworkCanvas, oAnnotationCanvas, false);

			// Clear the SVG search.
			g_oSVGSearch.clearSVGSearch(oArtworkCanvas, oAnnotationCanvas, true);
		}

		// Close any active confirm bubbles as these may be related to annotation actions.
		g_oGreenlightMessages.closeBubbles("Confirm");

		// Toggle the annotation document.
		g_oCompare.toggleAnnotationDocument();

		// Reset the canvas function.
		changeCanvasFunction();
	});

	// Toggle the overprint preview.
	$("#chkOverprintToggle").click(function () {

		// Toggle the overprint preview setting.
		g_oSeparations.ToggleOverprintPreview();

		// Get the image PNG data for the canvas.
		g_oViewer.g_oArtworkViewer.getimagePNGData(true, false);
	});

	// Update the colour of the overprint preview.
	$("#clrSelectOverprintColour, #setting_OverprintColour").on("change", function (event) {
		
		// Update the value of the users overprint colour.
		g_oSettings.g_oUserSettings.OverprintColour = event.target.id === "setting_OverprintColour" ? $("#setting_OverprintColour").val() : $("#clrSelectOverprintColour").val();

		// Update the settings.
		g_oSettings.updateSettingOverprintColour(true);

		// Get the image PNG data for the canvas.
		g_oViewer.g_oArtworkViewer.getimagePNGData(true, false);
	});

	// Activates the offset alignment mode.
	$("#OffsetAlignmentImg").on("click", function () {
		g_oCompare.setupCanvasForAlignment();
	});

	// Requests an automatic alignment
	$("#AutomaticAlignmentImg").on("click", function () {
		g_oCompare.g_oAutomaticAlignmentRequest = g_oCompare.GetCompareDocumentDetails();
		g_oCompare.activateCompare(g_oViewer.g_oCompareMode, g_oCompare.g_oCompareDocument, g_oCompare.g_oComparePage);
	});

	// Update the alignment tolerance.
	$("#GuidedTolerance").on("change", function () {
		g_oCompare.updateGuidedTolerance();
	});

	// Perform the manual alignment.
	$("#btnAlignment_Manual").click(function () {
		g_oCompare.performManualAlignment();
	});

	// Perform the guided alignment.
	$("#btnAlignment_Guided").click(function () {
		g_oCompare.performGuidedAlignment();
	});

	// Toggle the tolerance menu.
	$("#imgToleranceMenu").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		g_oCompare.hideAlignmentInformation();
		g_oCompare.toggleToleranceMenu();
	});

	$("#OffsetCompareRotation, #OffsetCompareRotationAnti, #CompareRotation_Compare, #CompareRotation_Compare_Anti").on("click", function () {
		// Determine direction.
		var bClockwise = (this.id === "OffsetCompareRotation" || this.id === "CompareRotation_Compare");

		// Rotate Compare Document.
		g_oCompare.updateCompareRotation(bClockwise);

		// Set the rotation of the compare rotation icons.
		$("#OffsetCompareRotation, #OffsetCompareRotationAnti, #CompareRotation_Compare, #CompareRotation_Compare_Anti")
			.css("transform", "rotate(" + g_oCompare.g_iCompareRotationDegrees + "deg)");
	});

	$("#CompareOffsetX").on("change", function (event) {
		
		// Validate the compare offset values.
		var oValidatedPosition = g_oCompare.validateComparePositions($("#CompareOffsetX").val(), $("#CompareOffsetY").val(), "AnnotationViewer", true);

		// Set the compare offset values.
		$("#CompareOffsetX").val(oValidatedPosition.xPos);
		$("#CompareOffsetY").val(oValidatedPosition.yPos);

		// Update the compare flags.
		g_oCompare.g_bManualAlignmentSet = true;
		g_oCompare.g_oAutomaticAlignmentRequest = null;

		// Update the compare offset.
		g_oCompare.updateCompareOffset(true);
	});

	$("#CompareOffsetY").on("change", function (event) {
		
		// Validate the compare offset values.
		var oValidatedPosition = g_oCompare.validateComparePositions($("#CompareOffsetX").val(), $("#CompareOffsetY").val(), "AnnotationViewer", true);

		// Set the compare offset values.
		$("#CompareOffsetX").val(oValidatedPosition.xPos);
		$("#CompareOffsetY").val(oValidatedPosition.yPos);

		// Update the compare flags.
		g_oCompare.g_bManualAlignmentSet = true;
		g_oCompare.g_oAutomaticAlignmentRequest = null;

		// Update the compare offset.
		g_oCompare.updateCompareOffset(true);
	});

	$("#btnAlignmentMarker_Viewer").click(function () {

		// Set this as the last selected alignment tool.
		g_oCompare.g_szLastAlignmentTool = "btnAlignmentMarker_Viewer";

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerAlignmentTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareAlignmentTools .selectedButton").removeClass("selectedButton");
		highlightSelectedButton($("#btnAlignmentMarker_Viewer"), false);
		highlightSelectedButton($("#btnAlignmentMarker_Compare"), false);

		// Setup the marker placement.
		g_oCompare.markerPlacement();
		
		// Update the cursor for each canvas.
		$("#AnnotationViewer").css('cursor', 'crosshair');
		g_oAnnotations.g_szPrevCursorStyle = "crosshair";
		$("#CompareAnnotationViewer").css('cursor', 'crosshair');
		$("#DifferencesAnnotationViewer").css('cursor', 'default');
	});

	$("#btnAlignmentMarker_Compare").click(function () {

		// Set this as the last selected alignment tool.
		g_oCompare.g_szLastAlignmentTool = "btnAlignmentMarker_Compare";

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerAlignmentTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareAlignmentTools .selectedButton").removeClass("selectedButton");
		highlightSelectedButton($("#btnAlignmentMarker_Viewer"), false);
		highlightSelectedButton($("#btnAlignmentMarker_Compare"), false);

		// Setup the marker placement.
		g_oCompare.markerPlacement();
		
		// Update the cursor for each canvas.
		$("#AnnotationViewer").css('cursor', 'crosshair');
		g_oAnnotations.g_szPrevCursorStyle = "crosshair";
		$("#CompareAnnotationViewer").css('cursor', 'crosshair');
		$("#DifferencesAnnotationViewer").css('cursor', 'default');
	});

	$("#btnAlignmentKeys_Viewer").click(function () {

		// Set this as the last selected alignment tool.
		g_oCompare.g_szLastAlignmentTool = "btnAlignmentKeys_Viewer";

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerAlignmentTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareAlignmentTools .selectedButton").removeClass("selectedButton");
		highlightSelectedButton($("#btnAlignmentKeys_Viewer"), false);

		// Setup the marker fine tune.
		g_oCompare.markerFineTune(g_oCompare.g_oAnnotationViewer.g_szCanvasId);

		// Update the cursor for each canvas.
		$("#AnnotationViewer").css('cursor', 'default');
		g_oAnnotations.g_szPrevCursorStyle = "default";
		$("#CompareAnnotationViewer").css('cursor', 'default');
		$("#DifferencesAnnotationViewer").css('cursor', 'default');
	});

	$("#btnAlignmentKeys_Compare").click(function () {

		// Set this as the last selected alignment tool.
		g_oCompare.g_szLastAlignmentTool = "btnAlignmentKeys_Compare";

		// Setup the icon.
		$("#tblNavTools .selectedButton").removeClass("selectedButton");
		$("#tblViewerAlignmentTools .selectedButton").removeClass("selectedButton");
		$("#tblCompareAlignmentTools .selectedButton").removeClass("selectedButton");
		highlightSelectedButton($("#btnAlignmentKeys_Compare"), false);

		// Setup the marker fine tune.
		g_oCompare.markerFineTune(g_oCompare.g_oCompareAnnotationViewer.g_szCanvasId);

		// Update the cursor for each canvas.
		$("#AnnotationViewer").css('cursor', 'default');
		g_oAnnotations.g_szPrevCursorStyle = "default";
		$("#CompareAnnotationViewer").css('cursor', 'default');
		$("#DifferencesAnnotationViewer").css('cursor', 'default');
	});

	$("#AlignmentX_Viewer").on("change", function (event) {
		g_oCompare.updateMarkerAlignment($("#AlignmentX_Viewer").val(), $("#AlignmentY_Viewer").val(), "AnnotationViewer");
	});

	$("#AlignmentY_Viewer").on("change", function (event) {
		g_oCompare.updateMarkerAlignment($("#AlignmentX_Viewer").val(), $("#AlignmentY_Viewer").val(), "AnnotationViewer");
	});

	$("#AlignmentX_Compare").on("change", function (event) {
		g_oCompare.updateMarkerAlignment($("#AlignmentX_Compare").val(), $("#AlignmentY_Compare").val(), "CompareAnnotationViewer");
	});

	$("#AlignmentY_Compare").on("change", function (event) {
		g_oCompare.updateMarkerAlignment($("#AlignmentX_Compare").val(), $("#AlignmentY_Compare").val(), "CompareAnnotationViewer");
	});

	// Confirms the alignment.
	$("#btnAlignmentConfirm_Differences").click(function () {
		g_oCompare.hideAlignmentInformation();
		g_oCompare.confirmMarkerPositions();
	});

	// Cancels the alignment.
	$("#btnAlignmentCancel_Differences").click(function () {
		g_oCompare.hideAlignmentInformation();
		g_oCompare.cancelMarkerPositions();
	});

	// Resets the offset alignment mode.
	$("#btnAlignmentReset_Differences").on("click", function () {
		g_oCompare.hideAlignmentInformation();
		g_oCompare.resetAlignmentMode();
	});

	// Toggle the alignment information.
	$("#btnAlignmentInfo_Differences").on("click", function () {
		g_oCompare.toggleAlignmentInformation();
	});

	// Activates the text compare mode.
	$("#TextCompare").on("click", function () {
		g_oCompare.setupCanvasForTextCompare();
	});

	// Exits the text compare mode.
	$("#btnExitCompare_Common_TextCompare").on("click", function () {

		// If the review screen is open, close this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Reset the differences.
		g_oTextCompare.resetDifferences();

		// Reset the hidden separations.
		g_oTextCompare.resetTextCompareHiddenSeparations();

		// Store the active text selection groups.
		g_oTextCompare.storeActiveTextSelectionGroups();

		// Hide the text compare information.
		g_oTextCompare.hideTextCompareInformation();

		// Hide the separations.
		g_oTextCompare.hideTextCompareSeparations();

		// Hide the text compare div.
		g_oTextCompare.hideTextCompareDiv();

		// Exit text compare mode.
		g_oCompare.exitTextCompareMode();
	});

	// Reviews the text compare.
	$("#btnReviewCompare_Common_TextCompare").on("click", function () {

		// Hide the text compare information slide out.
		g_oTextCompare.hideTextCompareInformation();

		// Hide the separations.
		g_oTextCompare.hideTextCompareSeparations();

		// If we do not have the text compare div show and we are not changing back from a text comparison, show this.
		if (!g_oTextCompare.g_bTextCompareDivShown && !g_oTextCompare.g_bDifferencesCalculated) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Reset the differences.
		g_oTextCompare.resetDifferences();
	});
	
	// Calculates the text compare.
	$("#btnCompareText_Common_TextCompare").on("click", function () {

		// Hide the text compare information slide out.
		g_oTextCompare.hideTextCompareInformation();

		// Hide the separations.
		g_oTextCompare.hideTextCompareSeparations();

		// If we do not have the text compare div show, show this.
		if (!g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Calulcate the differences.
		g_oTextCompare.calculateDifferences();
	});

	// Toggles the text compare div.
	$("#divTextCompareButton").on("click", function () {
		g_oTextCompare.hideTextCompareInformation();
		g_oTextCompare.hideTextCompareSeparations();
		g_oTextCompare.toggleTextCompareDiv();
	});

	// Toggle the text compare auto selection.
	$("#btnAuto_Select_Toggle_TextCompare").on("click", function () {

		// Ensure the setting is not locked.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonAutoSelection) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextCompare_AutoSelection.c_szSettingLocked);
			return;
		}

		// Update the text comparison whitespace detection.
		g_oSettings.g_oUserSettings.TextComparisonAutoSelection = $("#setting_TextComparisonAutoSelection").val() == '2' ? '1' : '2'; // Off = 1, On = 2

		// Set the auto selection toggle button icon.
		$("#btnAuto_Select_Toggle_TextCompare")
			.attr("src", g_oSettings.g_oUserSettings.TextComparisonAutoSelection == '2' ? "img/MagicWand_24_Blue.png" : "img/MagicWand_24_Grey.png")
			.tooltipster('content', g_oSettings.g_oUserSettings.TextComparisonAutoSelection == '2' ? g_oTextCompare_AutoSelection.c_szAutoSelectionDisabled : g_oTextCompare_AutoSelection.c_szAutoSelectionEnabled);

		// Update the setting.
		g_oSettings.updateSettingTextComparisonAutoSelection(true);

		// If we are not actively in a text comaprison, update the text comparison whitespace detection.
		if (!g_oTextCompare.g_bDifferencesCalculated) {
			$("#divTextComparisonAutoSelection").val(g_oSettings.g_oUserSettings.TextComparisonAutoSelection);
		}
	});

	// Update the text comparison fuzzy threshold.
	$("#setting_TextComparisonAutoSelection_FuzzyThreshold").on("change", function () {
		var value = parseInt($(this).val(), 10);

		// Ensure the value is between 0 and 100
		if (isNaN(value) || value < 0) {
			value = 0;
		} else if (value > 100) {
			value = 100;
		}

		$(this).val(value);

		// Update the fuzzy threshold setting
		g_oSettings.g_oUserSettings.TextComparisonAutoSelectionFuzzyThreshold = value;

		// Optionally, you can call a function to update the setting in your application
		g_oSettings.updateSettingTextComparisonFuzzyThreshold(true);
	});

	// Toggle the text compare information.
	$("#btnInfo_Common_TextCompare").on("click", function () {

		// If we have the text compare div show, hide this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Toggle the compare information.
		g_oTextCompare.toggleTextCompareInformation();
	});

	// Start auto-auto matching process.
	$("#btnFullDocumentSelection_Common_TextCompare").on("click", function () {

		// If we have the text compare div show, hide this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		g_oTextCompare.toggleTextCompareFullDocumentSelectionOptions();
	});

	// Toggle the text compare separations.
	$("#btnSeparations_Common_TextCompare").on("click", function () {

		// If we have the text compare div show, hide this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Toggle the separations.
		g_oTextCompare.toggleTextCompareSeparations();
	});

	// Change the text compare highlight colour.
	$("#btnColour_Common_TextCompare").on("click", function () {

		// If we have the text compare div show, hide this.
		if (g_oTextCompare.g_bTextCompareDivShown) {
			g_oTextCompare.toggleTextCompareDiv();
		}

		// Toggle the separations.
		g_oTextCompare.toggleTextCompareHighlightColour();
	});

	/**
	 * Window Events.
	*/

	// Keyboard shortcuts - KeyUp event
	$(window).keyup(function (event) {

		// Get the code of the key used for the key down.
		var iKeycode = event.keyCode || event.which;

		// Used to determine if we should proceed with the action.
		var bPerformKeyboardShortcut = true;

		// Used for highlighting button
		var thisParent = null;

		// Store the action we are performing
		var iKeyboardShortcutBehaviour = null;

		// If the key is in the array of keys pressed (Currently only added when it is a valid shortcut)
		if (iaKeysPressed.indexOf(iKeycode) !== -1) {

			// Remove from array
			iaKeysPressed.splice(iaKeysPressed.indexOf(iKeycode), 1);

			// Check the key we have released.
			switch (iKeycode) {

				// 32 Space
				case 32:

					// If we are in text compare mode.
					if (g_oTextCompare.g_bTextCompareInProgress) {
						
						// We have used the pan text compare tool.
						thisParent = $("#btnPan_Viewer_TextCompare");
						iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.PanTextCompare;
					}
					// If we are not in text compare mode.
					else {

						// We have used the pan tool.
						thisParent = $("#btnPan").parent();
						iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.Pan;
					}
					break;

				// Default.
				default:
					bPerformKeyboardShortcut = false;
					break;
			}

			// If the current active element is defined as being of type 'input' or is set as 'contentEditable' do not perform any actions
			if (document.activeElement.contentEditable.toLowerCase() === "true" || document.activeElement.nodeName.toLowerCase() === "input") {
				bPerformKeyboardShortcut = false;
			}

			// Determine the tool we have used.
			if (bPerformKeyboardShortcut) {
				switch (iKeyboardShortcutBehaviour) {

					// If we have used the pan tool.
					case eKeyboardShorcutBehaviours.Pan:

						// Clear any exiting highlight.
						clearHighlightSelectedButton(thisParent);

						// Get the canvas.
						var oaCanvasObjects = g_oViewer.getArtworkCanvas();
						for (var i = 0; i < oaCanvasObjects.length; i++) {
							// Unbind the click, pointer up and pointer down events, stop the drag action.
							changeCanvasFunction($("#" + oaCanvasObjects[i].g_oAnnotationCanvas.g_szCanvasId));
							if (oaCanvasObjects[i].g_oDoc !== null) {
								// 3D canvases do not have the drag discontinue method.
								if (oaCanvasObjects[i] instanceof Canvas) {
									oaCanvasObjects[i].dragDiscontinue(false, []);
								}
							}
						}

						// If the last used tool was a marquee, re-activate this.
						if (bIsMarqueeZoomLastTool) {

							// Click the Marquee zoom button, and set the selected class.
							$('#btnZoomMarquee').parent().addClass('selectedButton');
							$('#btnZoomMarquee').click();
						}
						// Otherwise default back to the pan tool.
						else {

							// Click the Pan button, and set the selected class.
							$('#btnPan').parent().addClass('selectedButton');
							$('#btnPan').click();
						}
						break;

					// If we have used the pan individual tool.
					case eKeyboardShorcutBehaviours.PanTextCompare:

						// End the pan on the canvas to stop any existing dragging.
						g_oViewer.g_oArtworkViewer.dragDiscontinue(false, g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));

						// Re-activate any text compare tool.
						g_oTextCompare.setActiveTextSelectionTool();
						break;
				}
			}
		}

	});

	// Keyboard shortcuts - KeyDown event
	$(window).keydown(function (event) {

		// Get the code of the key used for the key down.
		var iKeycode = event.keyCode || event.which;
		// Used to determine if we should proceed with the action.
		var bPerformKeyboardShortcut = true;
		// Used for highlighting button
		var thisParent = null;
		// Store the action we are performing
		var iKeyboardShortcutBehaviour = null;

		// CTRL(Windows) or CMD(Mac) is pressed.
		if (event.ctrlKey || event.metaKey) {
			switch (iKeycode) {
				case 61:	// 61	PlusEqual key: +/=
				case 107:	// 107	NumPad Key:	+
				case 187:	// 187 Equals key: = (Some browsers/keyboards seem to pick up this = instead of the above += of code 61)
					thisParent = $("#btnZoomIn").parent();
					iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.ZoomIn;
					break;
				case 109:	// 109	NumPad Key:	-
				case 173:	// 173	Minus/Underscore: _/-
				case 189:	// 189	Minus: - (Some browsers/keyboards seem to pick up this instead of the above code 173)
					thisParent = $("#btnZoomOut").parent();
					iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.ZoomOut;
					break;
				case 48:	// 48	Zero/Bracket: )/0
				case 96:	// 96	NumPad Key:	0
					thisParent = $("#btnZoomReset").parent();
					iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.ZoomReset;
					break;
				default:
					bPerformKeyboardShortcut = false;
					break;
			}

			// If we are currently dragging, do not perform any zoom.
			if (g_oViewer.g_oArtworkViewer.g_bIsDragging) {
				bPerformKeyboardShortcut = false;
			}
		}
		else {

			// Determine the key code that has been pressed.
			switch (iKeycode) {

				// 32 Space.
				case 32:

					// If we are in text compare mode.
					if (g_oTextCompare.g_bTextCompareInProgress) {

						// Store the current text compare tool if required.
						if (g_oTextTools.g_bHighlightInProgress) {
							g_oTextCompare.storeActiveTextSelectionTool();
						}

						// Set that we have used the pan text compare shortcut.
						iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.PanTextCompare;
					}
					else {

						// Set that we have used the pan shortcut.
						thisParent = $("#btnPan").parent();
						iKeyboardShortcutBehaviour = eKeyboardShorcutBehaviours.Pan;
					}
					break;

				// Default.
				default:
					bPerformKeyboardShortcut = false;
					break;
			}
		}

		// If the current active element is defined as being of type 'input' or is set as 'contentEditable'.
		if (document.activeElement.contentEditable.toLowerCase() === "true" || document.activeElement.nodeName.toLowerCase() === "input") {

			// Check this is not one of the toolbar images as these fall under the input node name.
			if (!document.activeElement.classList.contains("ToolbarImage")) {

				// Do not perform any actions.
				bPerformKeyboardShortcut = false;
			}
		}

		// Make sure we are performing the action and that it isn't a repeat of a 'keydown' event
		if (bPerformKeyboardShortcut && (iaKeysPressed.indexOf(iKeycode) === -1)) {

			// If we have a button to highlight.
			if (thisParent !== null) {

				// Pan performs different highlight functionality.
				if (iKeyboardShortcutBehaviour !== eKeyboardShorcutBehaviours.Pan && iKeyboardShortcutBehaviour !== eKeyboardShorcutBehaviours.PanTextCompare) {
					highlightSelectedButton(thisParent, false);
					setTimeout(function () { clearHighlightSelectedButton(thisParent); }, 500);
				}
				else {
					// Before removing all classes, check to see if the Zoom Marquee tool was the last tool to be used.
					bIsMarqueeZoomLastTool = $('#btnZoomMarquee').parent().prop('className') == "selectedButton";
					$("#tblNavTools .selectedButton").removeClass("selectedButton");
					$("#tblViewerNavTools .selectedButton").removeClass("selectedButton");
					$("#tblCompareNavTools .selectedButton").removeClass("selectedButton");
					highlightButtonClearingAllIcons(thisParent, true);
				}
			}

			// Perform the action
			switch (iKeyboardShortcutBehaviour) {
				case eKeyboardShorcutBehaviours.ZoomIn:
					g_oViewer.zoomIn(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
					break;
				case eKeyboardShorcutBehaviours.ZoomOut:
					g_oViewer.zoomOut(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
					break;
				case eKeyboardShorcutBehaviours.ZoomReset:
					g_oViewer.zoomReset(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
					break;
				case eKeyboardShorcutBehaviours.Pan:

					// Ensure that an annotation save action doesn't overwrite this function's event handlers.
					g_oAnnotations.currentTimeoutListClear();

					// Pan and sync the canvas.
					g_oViewer.pan(g_oCompare.getSyncCanvas(g_oViewer.g_oArtworkViewer));
					g_oCompare.pan(g_oCompare.getSyncCanvas(g_oCompare.g_oCompareViewer));

					// Add to array to prevent multiple 'keydown' events without a 'keyup' event
					iaKeysPressed.push(iKeycode);
					break;
				case eKeyboardShorcutBehaviours.PanTextCompare:

					// Ensure that an annotation save action doesn't overwrite this function's event handlers.
					g_oAnnotations.currentTimeoutListClear();

					// Pan and dont sync the canvas.
					$("#btnPan_Viewer_TextCompare").click();

					// Add to array to prevent multiple 'keydown' events without a 'keyup' event.
					iaKeysPressed.push(iKeycode);
					break;
			}
		}

		// Disables browser shortcuts, unless the space bar is pressed then allow for the original functionality to proceed.
		if (iKeyboardShortcutBehaviour != null && iKeyboardShortcutBehaviour > 0 &&
			iKeyboardShortcutBehaviour != eKeyboardShorcutBehaviours.Pan &&
			iKeyboardShortcutBehaviour != eKeyboardShorcutBehaviours.PanTextCompare) {
			return false;
		}

		// If we are in a jqte text editor with disabled shortcuts.
		if (document.activeElement.className.indexOf("jqte_editor") != -1 && document.activeElement.getAttribute("data-disableshortcuts") === "true") {

			// Determine if we are allowed to use this shortcut.
			var bAllowShortcut = true;

			// CTRL(Windows) or CMD(Mac) is pressed
			if (event.ctrlKey || event.metaKey) {
				switch (iKeycode) {

					// Disabled shortcuts.
					case 66: // B - Bold.
					case 85: // U - Underlines.
					case 73: // I - Italics.
					case 75: // K - Strike Through.
					case 76: // L - Link.
					case 72: // H - Horizontal Rule.
					case 190: // . - Ordered List.
					case 188: // , - Un-Ordered List.
						bAllowShortcut = false;
						break;
				}
			}

			// Return the result.
			return bAllowShortcut;
		}

		// If we are in point to point alignment.
		if (g_oCompare.g_bAlignmentModeActive) {
			// CTRL(Windows) or CMD(Mac) is pressed.
			if (event.ctrlKey || event.metaKey) {
				switch (iKeycode) {
					// M - Manual Alignment.
					case 77: event.preventDefault(); g_oCompare.performManualAlignment(); break;
					// A - Automatic Alignment.
					case 65: event.preventDefault(); g_oCompare.performGuidedAlignment(); break;
				}
			}
		}

		// If we are in text compare mode.
		if (g_oTextCompare.g_bTextCompareInProgress) {
			// ALT key is pressed.
			if (event.altKey) {
				switch (iKeycode) {
					// A (Approval Text Highlight)
					case 65: $("#btnTextHighlight_Viewer_TextCompare").click(); break;
					// C (Compare Text Highlight)
					case 67: $("#btnTextHighlight_Compare_TextCompare").click(); break;
					// R (Review Text Highlight)
					case 82: $("#btnReviewCompare_Common_TextCompare").click(); break;
				}
			}
		}
	});

	// On resize.
	$(window).on("resize", debounce(function resize() {
		g_oApproval.g_bDocNotChanged = true;

		// If we are on a mobile, only perform screen resize on orientation changes.
		if (typeof window.orientation !== 'undefined') {
			return;
		}

		// If we do not have an active compare mode.
		if (g_oViewer.g_oCompareMode == eCompareMode.NoCompare) {

			// Resize the main viewer window.
			g_oViewer.resizeWindow();
		}
		// If we are in text compare mode.
		else if (g_oTextCompare.g_bTextCompareInProgress) {

			// Store the active text selection groups.
			g_oTextCompare.storeActiveTextSelectionGroups();

			// Re-activate the compare mode with the screen size changes.
			g_oCompare.activateCompare(g_oViewer.g_oCompareMode, g_oCompare.g_oCompareDocument, g_oCompare.g_oComparePage);

			// Update the text compare div.
			g_oTextCompare.updateTextCompareDiv();
		}
		// If we have an activate compare mode.
		else {
			
			// Re-activate the compare mode with the screen size changes.
			g_oCompare.activateCompare(g_oViewer.g_oCompareMode, g_oCompare.g_oCompareDocument, g_oCompare.g_oComparePage);
		}

		// Check if we need to redraw calipers.
		if (g_oTechTools.IsCaliperRedrawMode()) {
			g_oSavedCalipers.RebindCaliperRedrawEvent();
		}

		// Resize the modal overlay.
		g_oAnnotationAttachments.modalOverlayResize();

		// Handle the colour selection bubble if available.
		Annotation.prototype.ResizeColourSelection(true);
	}, 250));

	// On orientation change.
	$(window).on("orientationchange", debounce(function resize() {
		g_oApproval.g_bDocNotChanged = true;
		// If we do not have an active compare mode.
		if (g_oViewer.g_oCompareMode == eCompareMode.NoCompare) {

			// Resize the main viewer window.
			g_oViewer.resizeWindow();
		}
		// If we have an activate compare mode.
		else {

			// Re-activate the compare mode with the screen size changes.
			g_oCompare.activateCompare(g_oViewer.g_oCompareMode, g_oCompare.g_oCompareDocument, g_oCompare.g_oComparePage);
		}
	}, 250));
});